/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "ledger/models.proto" (package "rd.ledger", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Method_Type } from "../company/tender/models_pb";
import { FractionalMoney } from "../proto/money/models_pb";
import { BankPaymentMethod } from "../payments/models_pb";
import { Card } from "../payments/models_pb";
import { CashRegister } from "../company/models_pb";
import { Decimal } from "../proto/decimal/models_pb";
import { Money } from "../proto/money/models_pb";
import { User } from "../user/models_pb";
import { Timestamp } from "../google/protobuf/timestamp_pb";
import { UUID } from "../proto/uuid/models_pb";
/**
 * LedgerEntry represents a monetary transaction on a set of sales, either
 * payments or refunds. Total is non-duplicative because it may be greater than
 * the sum of values of allocations by sale, resulting in an account credit.
 *
 * @generated from protobuf message rd.ledger.LedgerEntry
 */
export interface LedgerEntry {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 5
     */
    customerId?: UUID; // for job accounts, this is the parent customer id
    /**
     * @generated from protobuf field: rd.user.User created_by = 6
     */
    createdBy?: User;
    /**
     * Amount is the dollar amount being transacted.
     * the sign is from the customer's balance perspective, i.e. how much they
     * owe:
     * - Purchases, Refunds, Reverse Discounts & Financing Charges are positive (increasing balance).
     * - Write Offs, Returns, Discounts & Payments are negative (decreasing balance).
     * - Allocations have zero amount and only record the allocation of payments to charges.
     * - A discount ledger entry will be recorded when a discount action is performed.
     * - A reverse ledger entry will be recorded when a discount action is reversed
     * - An inventory hold amount is the cost x quantity committed
     *
     * @generated from protobuf field: rd.proto.money.Money amount = 7
     */
    amount?: Money;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.Type type = 8
     */
    type: LedgerEntry_Type;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.Purchase purchase = 9
     */
    purchase?: LedgerEntry_Purchase;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.Return return = 10
     */
    return?: LedgerEntry_Return;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.Payment payment = 11
     */
    payment?: LedgerEntry_Payment;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.Refund refund = 13
     */
    refund?: LedgerEntry_Refund;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 14
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.PettyCash petty_cash = 15
     */
    pettyCash?: LedgerEntry_PettyCash;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.CloseOut close_out = 16
     */
    closeOut?: LedgerEntry_CloseOut;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.Allocation allocation = 17
     */
    allocation?: LedgerEntry_Allocation;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.Discount discount = 18
     */
    discount?: LedgerEntry_Discount;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.ReverseDiscount reverse_discount = 19
     */
    reverseDiscount?: LedgerEntry_ReverseDiscount;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 20
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID job_ids = 21
     */
    jobIds: UUID[]; // customer id for job accounts
    /**
     * @generated from protobuf field: repeated string debug_notes = 39
     */
    debugNotes: string[];
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.InventoryHold inventory_hold = 40
     */
    inventoryHold?: LedgerEntry_InventoryHold;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.InventoryOrder inventory_order = 41
     */
    inventoryOrder?: LedgerEntry_InventoryOrder;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.InventoryReceipt inventory_receipt = 42
     */
    inventoryReceipt?: LedgerEntry_InventoryReceipt;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.InventoryRelease inventory_release = 43
     */
    inventoryRelease?: LedgerEntry_InventoryRelease;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.InventoryCount inventory_count = 44
     */
    inventoryCount?: LedgerEntry_InventoryCount;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.InventoryCostEdit inventory_cost_edit = 45
     */
    inventoryCostEdit?: LedgerEntry_InventoryCostEdit;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.InventoryMetadata inventory_metadata = 46
     */
    inventoryMetadata?: LedgerEntry_InventoryMetadata;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.DepositPurchase deposit_purchase = 48
     */
    depositPurchase?: LedgerEntry_DepositPurchase;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.DepositRedemption deposit_redemption = 49
     */
    depositRedemption?: LedgerEntry_DepositRedemption;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.DepositForfeiture deposit_forfeiture = 50
     */
    depositForfeiture?: LedgerEntry_DepositForfeiture;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.FinancingCharge financing_charge = 51
     */
    financingCharge?: LedgerEntry_FinancingCharge;
    /**
     * For tracking time of edit
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 52
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 53
     */
    updatedBy?: User;
    /**
     * For tracking time at which it should show in accounting/reports
     *
     * @generated from protobuf field: google.protobuf.Timestamp accounted_at = 54
     */
    accountedAt?: Timestamp;
    /**
     * Added to ledger entries that are reversed
     *
     * @generated from protobuf field: bool is_reversed = 55
     */
    isReversed: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp reversed_at = 56
     */
    reversedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User reversed_by = 57
     */
    reversedBy?: User;
    /**
     * Added to ledger entries that are reversing other ledger entries
     *
     * @generated from protobuf field: bool is_reversal = 58
     */
    isReversal: boolean;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID reversed_ledger_entry_id = 59
     */
    reversedLedgerEntryId?: UUID;
    /**
     * Added to ledger entries that replace other ledger entries
     *
     * @generated from protobuf field: bool is_replacement = 60
     */
    isReplacement: boolean;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID replaced_ledger_entry_id = 61
     */
    replacedLedgerEntryId?: UUID;
    /**
     * Added to reversals and replacements to easily query the chain of ledger entries
     *
     * @generated from protobuf field: rd.proto.uuid.UUID original_ledger_entry_id = 62
     */
    originalLedgerEntryId?: UUID;
    /**
     * Added to original ledger entries to know if it was replaced
     *
     * @generated from protobuf field: rd.proto.uuid.UUID active_replacement_ledger_entry_id = 63
     */
    activeReplacementLedgerEntryId?: UUID;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.ReceivablesMetadata receivables_metadata = 64
     */
    receivablesMetadata?: LedgerEntry_ReceivablesMetadata;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.GiftCardActivation gift_card_activation = 65
     */
    giftCardActivation?: LedgerEntry_GiftCardActivation;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.GiftCardDeactivation gift_card_deactivation = 66
     */
    giftCardDeactivation?: LedgerEntry_GiftCardDeactivation;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.LoyaltyPoints loyalty_points = 67
     */
    loyaltyPoints?: LedgerEntry_LoyaltyPoints;
}
/**
 * a potential discount is used to record one type of discount that can be potentially applied to
 * the payment of a purchase.
 *
 * @generated from protobuf message rd.ledger.LedgerEntry.PotentialDiscount
 */
export interface LedgerEntry_PotentialDiscount {
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.PotentialDiscount.Type type = 1
     */
    type: LedgerEntry_PotentialDiscount_Type; // used to specify a discount type
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal rate = 3
     */
    rate?: Decimal; // indicate the discount rate
    /**
     * @generated from protobuf field: string term_name = 4
     */
    termName: string; // the name of a discount term
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 5
     */
    expiresAt?: Timestamp; // specify when the discount expires
}
/**
 * for discount type
 *
 * @generated from protobuf enum rd.ledger.LedgerEntry.PotentialDiscount.Type
 */
export enum LedgerEntry_PotentialDiscount_Type {
    /**
     * @generated from protobuf enum value: DISCOUNT_TYPE_UNDEFINED = 0;
     */
    DISCOUNT_TYPE_UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: DISCOUNT_TYPE_EARLY_FULL_PAYMENT = 1;
     */
    DISCOUNT_TYPE_EARLY_FULL_PAYMENT = 1
}
/**
 * Purchases are giving inventory to customers
 *
 * @generated from protobuf message rd.ledger.LedgerEntry.Purchase
 */
export interface LedgerEntry_Purchase {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 1
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp due_at = 2
     */
    dueAt?: Timestamp;
    /**
     * @generated from protobuf field: repeated rd.ledger.LedgerEntry.PotentialDiscount potential_discounts = 3
     */
    potentialDiscounts: LedgerEntry_PotentialDiscount[]; // the discounts that could be applied to payments
}
/**
 * Returns are customers giving inventory back
 *
 * @generated from protobuf message rd.ledger.LedgerEntry.Return
 */
export interface LedgerEntry_Return {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID purchase_ledger_entry_id = 1
     */
    purchaseLedgerEntryId?: UUID; // may be nil if unallocated
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID returned_from_sale_id = 2
     */
    returnedFromSaleId?: UUID; // original sale id. may be nil if unallocated
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 4
     */
    saleId?: UUID; // sale id of transaction itself
    /**
     * @generated from protobuf field: bool is_unallocated = 5
     */
    isUnallocated: boolean; // does not affect purchase balance automatically
    /**
     * @generated from protobuf field: rd.proto.money.Money unallocated_credits_added = 6
     */
    unallocatedCreditsAdded?: Money; // negative
}
/**
 * Payments are monetary payments from customers
 *
 * @generated from protobuf message rd.ledger.LedgerEntry.Payment
 */
export interface LedgerEntry_Payment {
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> purchase_allocations_by_id = 2
     */
    purchaseAllocationsById: {
        [key: string]: Money;
    }; // same sign convention as amt
    /**
     * @generated from protobuf field: rd.proto.money.Money cash_received = 4
     */
    cashReceived?: Money; // same sign convention as amt
    /**
     * @generated from protobuf field: string stripe_payment_intent_id = 5
     */
    stripePaymentIntentId: string;
    /**
     * @generated from protobuf field: string check_number = 6
     */
    checkNumber: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID bill_payment_id = 7
     */
    billPaymentId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.Money fee = 8
     */
    fee?: Money;
    /**
     * @generated from protobuf field: rd.company.CashRegister cash_register = 9
     */
    cashRegister?: CashRegister;
    /**
     * @generated from protobuf field: rd.payments.Card card = 10
     */
    card?: Card;
    /**
     * Sale payment: surcharge (and tax) are counted towards LE amount via purchase allocation
     * Bill payment: surcharge (and tax) are counted towards LE amount directly
     *
     * @generated from protobuf field: rd.proto.money.Money surcharge = 11
     */
    surcharge?: Money; // same sign convention as amt
    /**
     * @generated from protobuf field: rd.proto.money.Money surcharge_tax = 12
     */
    surchargeTax?: Money; // same sign convention as amt
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> finance_charge_allocations_by_id = 14
     */
    financeChargeAllocationsById: {
        [key: string]: Money;
    }; // payment allocations by the finance charge IDs
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> deposit_purchase_allocations_by_id = 15
     */
    depositPurchaseAllocationsById: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money unallocated_credits_added = 16
     */
    unallocatedCreditsAdded?: Money; // Negative. Tracks the amount of unallocated credits added through a bill payment.
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> payment_credit_allocations_by_id = 17
     */
    paymentCreditAllocationsById: {
        [key: string]: Money;
    }; // Positive. Tracks the unallocated credits generated from payments that were
    /**
     * used.
     *
     * @generated from protobuf field: map<string, rd.proto.money.Money> write_off_credit_allocations_by_id = 18
     */
    writeOffCreditAllocationsById: {
        [key: string]: Money;
    }; // Positive. Tracks the unallocated credits generated from write offs that were
    /**
     * used.
     *
     * @generated from protobuf field: map<string, rd.proto.money.Money> return_credit_allocations_by_id = 19
     */
    returnCreditAllocationsById: {
        [key: string]: Money;
    }; // Positive. Tracks the unallocated credits generated from returns that were used.
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID tender_method_id = 20
     */
    tenderMethodId?: UUID;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> fallback_allocations_by_id = 21
     */
    fallbackAllocationsById: {
        [key: string]: Money;
    }; // Catch-all for allocations that don't fit into the other allocation maps.
    /**
     * For internal use only.
     *
     * @generated from protobuf field: bool should_print_receipt = 22
     */
    shouldPrintReceipt: boolean;
    /**
     * @generated from protobuf field: string custom_note = 23
     */
    customNote: string;
    /**
     * @generated from protobuf field: string stripe_charge_id = 24
     */
    stripeChargeId: string;
    /**
     * @generated from protobuf field: rd.payments.BankPaymentMethod bank_payment_method = 25
     */
    bankPaymentMethod?: BankPaymentMethod;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID gift_card_activation_ledger_entry_id = 27
     */
    giftCardActivationLedgerEntryId?: UUID;
    /**
     * @generated from protobuf field: string gift_card_number_last_4 = 28
     */
    giftCardNumberLast4: string;
    /**
     * @generated from protobuf field: bool is_interac = 29
     */
    isInterac: boolean;
    /**
     * Per-rate breakdown of surcharge_tax, same sign convention as amt.
     *
     * @generated from protobuf field: map<string, rd.proto.money.Money> surcharge_tax_by_tax_rate_id = 30
     */
    surchargeTaxByTaxRateId: {
        [key: string]: Money;
    };
    /**
     * Negated cash tender rounding delta: negative when rounding up, positive when rounding down.
     * Sale payment allocations already include this delta; bill payment allocations exclude it.
     *
     * @generated from protobuf field: rd.proto.money.Money cash_rounding_delta = 31
     */
    cashRoundingDelta?: Money;
}
/**
 * Refunds are monetary payments to customers
 *
 * @generated from protobuf message rd.ledger.LedgerEntry.Refund
 */
export interface LedgerEntry_Refund {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID payment_ledger_entry_id = 1
     */
    paymentLedgerEntryId?: UUID; // optional for unlinked return refunds
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID return_ledger_entry_id = 2
     */
    returnLedgerEntryId?: UUID; // nil if bill payment refund
    /**
     * @generated from protobuf field: string stripe_refund_id = 3
     */
    stripeRefundId: string;
    /**
     * @generated from protobuf field: rd.company.CashRegister cash_register = 5
     */
    cashRegister?: CashRegister;
    /**
     * @generated from protobuf field: rd.proto.money.Money surcharge = 6
     */
    surcharge?: Money; // positive
    /**
     * @generated from protobuf field: rd.proto.money.Money surcharge_tax = 7
     */
    surchargeTax?: Money; // positive
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID deposit_redemption_ledger_entry_id = 8
     */
    depositRedemptionLedgerEntryId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.Money unallocated_credits = 9
     */
    unallocatedCredits?: Money; // positive. Tracks the amount of unallocated credits reversed
    /**
     * positive. undefined. needs to be backfilled
     *
     * @generated from protobuf field: map<string, rd.proto.money.Money> purchase_unallocations_by_id = 10
     */
    purchaseUnallocationsById: {
        [key: string]: Money;
    };
    /**
     * positive. undefined. needs to be backfilled
     *
     * @generated from protobuf field: map<string, rd.proto.money.Money> finance_charge_unallocations_by_id = 11
     */
    financeChargeUnallocationsById: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: bool is_unlinked_payment = 12
     */
    isUnlinkedPayment: boolean; // true if the refund is not linked to a payment
    /**
     * @generated from protobuf field: rd.payments.Card card = 13
     */
    card?: Card;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> payment_credit_unallocations_by_id = 14
     */
    paymentCreditUnallocationsById: {
        [key: string]: Money;
    }; // negative. Tracks the credits from payments that were unallocated in a bill payment
    /**
     * refund.
     *
     * @generated from protobuf field: map<string, rd.proto.money.Money> write_off_credit_unallocations_by_id = 15
     */
    writeOffCreditUnallocationsById: {
        [key: string]: Money;
    }; // negative. Tracks the credits from write offs that were unallocated in a bill payment
    /**
     * refund.
     *
     * @generated from protobuf field: rd.proto.money.Money fee = 16
     */
    fee?: Money;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> return_credit_unallocations_by_id = 17
     */
    returnCreditUnallocationsById: {
        [key: string]: Money;
    }; // negative. Tracks the credits from returns that were unallocated in a bill payment
    /**
     * refund.
     *
     * @generated from protobuf field: string stripe_charge_id = 18
     */
    stripeChargeId: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID tender_method_id = 19
     */
    tenderMethodId?: UUID;
    /**
     * @generated from protobuf field: string check_number = 20
     */
    checkNumber: string;
    /**
     * @generated from protobuf field: string custom_note = 21
     */
    customNote: string;
    /**
     * @generated from protobuf field: rd.payments.BankPaymentMethod bank_payment_method = 22
     */
    bankPaymentMethod?: BankPaymentMethod;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> fallback_unallocations_by_id = 23
     */
    fallbackUnallocationsById: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID gift_card_activation_ledger_entry_id = 25
     */
    giftCardActivationLedgerEntryId?: UUID;
    /**
     * @generated from protobuf field: string gift_card_number_last_4 = 26
     */
    giftCardNumberLast4: string;
    /**
     * undefined. needs to be backfilled
     *
     * @generated from protobuf field: rd.proto.uuid.UUID deposit_purchase_unallocation_ledger_entry_id = 27
     */
    depositPurchaseUnallocationLedgerEntryId?: UUID;
    /**
     * Per-rate breakdown of surcharge_tax; positive.
     *
     * @generated from protobuf field: map<string, rd.proto.money.Money> surcharge_tax_by_tax_rate_id = 28
     */
    surchargeTaxByTaxRateId: {
        [key: string]: Money;
    };
    /**
     * The rounding delta from the refund tender (e.g. cash refund of an unrounded
     * payment). positive = rounded up.
     *
     * @generated from protobuf field: rd.proto.money.Money cash_rounding_delta = 29
     */
    cashRoundingDelta?: Money;
    /**
     * Bills only. The rounding delta inherited from the original payment (e.g. check refund of a
     * cash-rounded payment). positive = rounded up.
     *
     * @generated from protobuf field: rd.proto.money.Money payment_cash_rounding_delta = 30
     */
    paymentCashRoundingDelta?: Money;
}
/**
 * Petty cash represents a deposit or withdrawal of cash to the register for company use.
 * Amount in Petty cash represents the monetary value of a withdrawal or a deposit.
 * +ve indicates a deposit -ve; -ve indicates a withdrawal
 *
 * @generated from protobuf message rd.ledger.LedgerEntry.PettyCash
 */
export interface LedgerEntry_PettyCash {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID petty_cash_id = 1
     */
    pettyCashId?: UUID;
    /**
     * @generated from protobuf field: rd.company.CashRegister cash_register = 2
     */
    cashRegister?: CashRegister;
}
/**
 * Close out represents a close out of the register in which total cash is counted.
 * Amount in Close out represents the amount over or short after a close out.
 * +ve indicates an over while -ve indicates a short
 *
 * @generated from protobuf message rd.ledger.LedgerEntry.CloseOut
 */
export interface LedgerEntry_CloseOut {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID close_out_id = 1
     */
    closeOutId?: UUID;
    /**
     * @generated from protobuf field: rd.company.CashRegister cash_register = 2
     */
    cashRegister?: CashRegister;
}
/**
 * @generated from protobuf message rd.ledger.LedgerEntry.Allocation
 */
export interface LedgerEntry_Allocation {
    /**
     * @generated from protobuf field: rd.proto.money.Money allocation_amount = 1
     */
    allocationAmount?: Money;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID payment_ledger_entry_id = 2
     */
    paymentLedgerEntryId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID purchase_ledger_entry_id = 3
     */
    purchaseLedgerEntryId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID write_off_ledger_entry_id = 4
     */
    writeOffLedgerEntryId?: UUID;
}
/**
 * @generated from protobuf message rd.ledger.LedgerEntry.Discount
 */
export interface LedgerEntry_Discount {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID purchase_ledger_entry_id = 1
     */
    purchaseLedgerEntryId?: UUID; // the associated purchase ledger entry id
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID purchase_location_id = 3
     */
    purchaseLocationId?: UUID; // the location where the related purchase occurs.
    /**
     * This is used for facilitating accounting.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID bill_payment_id = 4
     */
    billPaymentId?: UUID; // the bill payment that created the discount
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID returned_from_sale_id = 5
     */
    returnedFromSaleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 7
     */
    saleId?: UUID; // return id (sale.id or sale_return.id)
}
/**
 * @generated from protobuf message rd.ledger.LedgerEntry.ReverseDiscount
 */
export interface LedgerEntry_ReverseDiscount {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID purchase_ledger_entry_id = 1
     */
    purchaseLedgerEntryId?: UUID; // the associated purchase ledger entry id
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID discount_ledger_entry_id = 3
     */
    discountLedgerEntryId?: UUID; // refer to the discount that need to be reversed
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID purchase_location_id = 5
     */
    purchaseLocationId?: UUID; // the location where the related purchase occurs.
    /**
     * This is used for facilitating accounting.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID bill_payment_id = 6
     */
    billPaymentId?: UUID; // the bill payment refund that created the reverse discount
}
/**
 * @generated from protobuf message rd.ledger.LedgerEntry.UomSnapshot
 */
export interface LedgerEntry_UomSnapshot {
    /**
     * @generated from protobuf field: string uom_code = 1
     */
    uomCode: string;
    /**
     * @generated from protobuf field: string uom_name = 2
     */
    uomName: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal conversion_factor_to_base = 3
     */
    conversionFactorToBase?: Decimal; // must be positive
}
/**
 * The following ledger entries amounts are set based on if the primary account is being debited
 * or credited. The primary account is commented in each message declaration. The quantity MUST be
 * possitive.
 *
 * @generated from protobuf message rd.ledger.LedgerEntry.InventoryHold
 */
export interface LedgerEntry_InventoryHold {
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.InventoryHold.Subtype subtype = 1
     */
    subtype: LedgerEntry_InventoryHold_Subtype;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost = 3
     */
    cost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 4
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_product_id = 5
     */
    saleProductId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID transfer_id = 6
     */
    transferId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_id = 7
     */
    orderId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID reversed_id = 8
     */
    reversedId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_product_id = 9
     */
    orderProductId?: UUID;
    /**
     * @generated from protobuf field: bool is_special_order = 10
     */
    isSpecialOrder: boolean; // non-stock inventory accounting
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_committed_v2 = 11
     */
    quantityCommittedV2?: Decimal;
    /**
     * Quantity with Unit of Measure information
     *
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 12
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_committed_uom = 13
     */
    quantityCommittedUom?: Decimal;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 14
     */
    uomSnapshot?: LedgerEntry_UomSnapshot;
    /**
     * @generated from protobuf field: bool is_non_stock = 15
     */
    isNonStock: boolean;
}
/**
 * @generated from protobuf enum rd.ledger.LedgerEntry.InventoryHold.Subtype
 */
export enum LedgerEntry_InventoryHold_Subtype {
    /**
     * @generated from protobuf enum value: SUBTYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * primary: assets committed
     * normal:  debit committed, credit on hand
     * reverse: credit committed, debit on hand
     *
     * @generated from protobuf enum value: SUBTYPE_WILL_CALL = 1;
     */
    WILL_CALL = 1,
    /**
     * primary: assets committed
     * normal:  debit committed, credit on hand
     * reverse: credit committed, debit on hand
     *
     * @generated from protobuf enum value: SUBTYPE_TRANSFER_REQUEST = 2;
     */
    TRANSFER_REQUEST = 2,
    /**
     * primary: assets commited
     * normal:  debit committed, credit on hand
     * reverse: credit committed, debit on hand
     *
     * @generated from protobuf enum value: SUBTYPE_TRANSFER_DISPATCH = 3;
     */
    TRANSFER_DISPATCH = 3,
    /**
     * primary: assets commited
     * normal:  debit committed, credit on hand
     * reverse: credit committed, debit on hand
     *
     * @generated from protobuf enum value: SUBTYPE_ORDER_RETURN = 4;
     */
    ORDER_RETURN = 4,
    /**
     * primary: assets committed
     * normal:  debit committed, credit on hand
     * reverse: credit committed, debit on hand
     *
     * @generated from protobuf enum value: SUBTYPE_SPECIAL_ORDER = 5;
     */
    SPECIAL_ORDER = 5
}
/**
 * @generated from protobuf message rd.ledger.LedgerEntry.InventoryOrder
 */
export interface LedgerEntry_InventoryOrder {
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.InventoryOrder.Subtype subtype = 1
     */
    subtype: LedgerEntry_InventoryOrder_Subtype;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost = 3
     */
    cost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID transfer_id = 6
     */
    transferId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_id = 7
     */
    orderId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID reversed_id = 8
     */
    reversedId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_product_id = 9
     */
    orderProductId?: UUID;
    /**
     * @generated from protobuf field: bool is_special_order = 10
     */
    isSpecialOrder: boolean; // non-stock inventory accounting
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 11
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_product_id = 12
     */
    saleProductId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_ordered_v2 = 13
     */
    quantityOrderedV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 14
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_uom = 15
     */
    quantityUom?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal old_quantity_uom = 16
     */
    oldQuantityUom?: Decimal; // optional
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal new_quantity_uom = 17
     */
    newQuantityUom?: Decimal; // optional
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 18
     */
    uomSnapshot?: LedgerEntry_UomSnapshot;
    /**
     * @generated from protobuf field: bool is_non_stock = 19
     */
    isNonStock: boolean;
}
/**
 * @generated from protobuf enum rd.ledger.LedgerEntry.InventoryOrder.Subtype
 */
export enum LedgerEntry_InventoryOrder_Subtype {
    /**
     * @generated from protobuf enum value: SUBTYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * primary: assets on order
     * normal:  debit assets on order, credit liability pending order
     * reverse: credit assets on order, debit liability pending order
     *
     * @generated from protobuf enum value: SUBTYPE_TRANSFER_REQUEST = 1;
     */
    TRANSFER_REQUEST = 1,
    /**
     * primary: assets on order
     * normal:  debit assets on order, credit liability pending order
     * reverse: credit assets on order, debit liability pending order
     *
     * @generated from protobuf enum value: SUBTYPE_TRANSFER_DISPATCH = 2;
     */
    TRANSFER_DISPATCH = 2,
    /**
     * primary: assets on order
     * normal:  debit assets on order, credit liability pending order
     * reverse: credit assets on order, debit liability pending order
     *
     * @generated from protobuf enum value: SUBTYPE_ORDER = 3;
     */
    ORDER = 3,
    /**
     * primary: assets on order
     * normal:  debit assets on order, credit liability pending order
     * reverse: credit assets on order, debit liability pending order
     *
     * @generated from protobuf enum value: SUBTYPE_WILL_CALL_RETURN = 4;
     */
    WILL_CALL_RETURN = 4,
    /**
     * primary: assets on order
     * normal: debit assets on order, credit liability pending order
     * reverse: credit assets on order, debit liability pending order
     *
     * @generated from protobuf enum value: SUBTYPE_SPECIAL_ORDER_RETURN = 5;
     */
    SPECIAL_ORDER_RETURN = 5
}
/**
 * @generated from protobuf message rd.ledger.LedgerEntry.InventoryReceipt
 */
export interface LedgerEntry_InventoryReceipt {
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.InventoryReceipt.Subtype subtype = 1
     */
    subtype: LedgerEntry_InventoryReceipt_Subtype;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost = 3
     */
    cost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID returned_from_sale_id = 4
     */
    returnedFromSaleId?: UUID; // sold sale id
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID returned_from_sale_product_id = 5
     */
    returnedFromSaleProductId?: UUID; // sold sale product id
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID transfer_id = 7
     */
    transferId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_shipment_id = 8
     */
    orderShipmentId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_product_id = 9
     */
    orderProductId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 10
     */
    saleId?: UUID; // return sale id (sale.id or sale_return.id)
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_product_id = 11
     */
    saleProductId?: UUID; // return product id
    /**
     * @generated from protobuf field: bool is_special_order = 12
     */
    isSpecialOrder: boolean; // non-stock inventory accounting
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_received_v2 = 13
     */
    quantityReceivedV2?: Decimal;
    /**
     * @generated from protobuf field: bool is_non_stock = 17
     */
    isNonStock: boolean;
}
/**
 * @generated from protobuf enum rd.ledger.LedgerEntry.InventoryReceipt.Subtype
 */
export enum LedgerEntry_InventoryReceipt_Subtype {
    /**
     * @generated from protobuf enum value: SUBTYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * primary: on hand
     * normal:  debit on hand, credit expense transfers
     * reverse: N/A
     *
     * @generated from protobuf enum value: SUBTYPE_TRANSFER = 1;
     */
    TRANSFER = 1,
    /**
     * primary: on hand
     * normal:  debit on hand, credit liability accounts payable
     * reverse: N/A
     *
     * @generated from protobuf enum value: SUBTYPE_ORDER_SHIPMENT = 2;
     */
    ORDER_SHIPMENT = 2,
    /**
     * primary: on hand
     * normal:  debit on hand, credit expense transfers
     * reverse: N/A
     *
     * @generated from protobuf enum value: SUBTYPE_SALE_RETURN = 3;
     */
    SALE_RETURN = 3,
    /**
     * primary: cogs
     * normal:  debit expense transfer, credit cogs
     * reverse: N/A
     *
     * @generated from protobuf enum value: SUBTYPE_SALE_RETURN_ACK = 4;
     */
    SALE_RETURN_ACK = 4,
    /**
     * primary: on hand
     * normal:  debit on hand, credit cogs (expense transfer)
     * reverse: N/A
     *
     * @generated from protobuf enum value: SUBTYPE_UNLINKED_SALE_RETURN = 5;
     */
    UNLINKED_SALE_RETURN = 5,
    /**
     * @generated from protobuf enum value: SUBTYPE_VOIDED_SALE_REVERSAL = 6;
     */
    VOIDED_SALE_REVERSAL = 6,
    /**
     * primary: cogs
     * normal:  debit expense transfer, credit cogs
     * reverse: N/A
     *
     * @generated from protobuf enum value: SUBTYPE_UNLINKED_SALE_RETURN_ACK = 7;
     */
    UNLINKED_SALE_RETURN_ACK = 7,
    /**
     * primary: on hand
     * normal:  debit on hand, credit liability accounts payable
     * reverse: N/A
     *
     * @generated from protobuf enum value: SUBTYPE_ORDER_SHIPMENT_EDIT = 8;
     */
    ORDER_SHIPMENT_EDIT = 8
}
/**
 * @generated from protobuf message rd.ledger.LedgerEntry.InventoryRelease
 */
export interface LedgerEntry_InventoryRelease {
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.InventoryRelease.Subtype subtype = 1
     */
    subtype: LedgerEntry_InventoryRelease_Subtype;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost = 3
     */
    cost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 4
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_product_id = 5
     */
    saleProductId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID transfer_id = 6
     */
    transferId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_shipment_id = 7
     */
    orderShipmentId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_product_id = 8
     */
    orderProductId?: UUID;
    /**
     * @generated from protobuf field: bool is_special_order = 9
     */
    isSpecialOrder: boolean; // non-stock inventory accounting
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_released_v2 = 10
     */
    quantityReleasedV2?: Decimal;
    /**
     * @generated from protobuf field: bool is_non_stock = 14
     */
    isNonStock: boolean;
}
/**
 * @generated from protobuf enum rd.ledger.LedgerEntry.InventoryRelease.Subtype
 */
export enum LedgerEntry_InventoryRelease_Subtype {
    /**
     * @generated from protobuf enum value: SUBTYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * primary:  on hand
     * normal:   credit on hand, debit expense transfers
     * reverse:  N/A
     *
     * @generated from protobuf enum value: SUBTYPE_TRANSFER = 1;
     */
    TRANSFER = 1,
    /**
     * primary:  on hand
     * normal:   credit on hand, debit liability accounts payable
     * reverse:  N/A
     *
     * @generated from protobuf enum value: SUBTYPE_ORDER_SHIPMENT_RETURN = 2;
     */
    ORDER_SHIPMENT_RETURN = 2,
    /**
     * primary:  on hand
     * normal:   credit on hand, debit cogs (expense transfer)
     * reverse:  N/A
     *
     * @generated from protobuf enum value: SUBTYPE_SALE = 3;
     */
    SALE = 3,
    /**
     * @generated from protobuf enum value: SUBTYPE_VOIDED_RETURN_REVERSAL = 4;
     */
    VOIDED_RETURN_REVERSAL = 4,
    /**
     * primary: cogs
     * normal:  credit expense transfer, debit cogs
     * reverse: N/A
     *
     * @generated from protobuf enum value: SUBTYPE_SALE_ACK = 5;
     */
    SALE_ACK = 5,
    /**
     * primary:  on hand
     * normal:   credit on hand, debit liability accounts payable
     * reverse:  N/A
     *
     * @generated from protobuf enum value: SUBTYPE_ORDER_SHIPMENT_EDIT = 6;
     */
    ORDER_SHIPMENT_EDIT = 6
}
/**
 * @generated from protobuf message rd.ledger.LedgerEntry.InventoryCount
 */
export interface LedgerEntry_InventoryCount {
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.InventoryCount.Subtype subtype = 1
     */
    subtype: LedgerEntry_InventoryCount_Subtype;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost = 4
     */
    cost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID inventory_count_id = 5
     */
    inventoryCountId?: UUID;
    /**
     * @generated from protobuf field: bool is_special_order = 6
     */
    isSpecialOrder: boolean; // non-stock inventory accounting
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal new_quantity_v2 = 7
     */
    newQuantityV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal old_quantity_v2 = 8
     */
    oldQuantityV2?: Decimal;
    /**
     * Quantity with Unit of Measure information
     *
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 9
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal new_quantity_uom = 10
     */
    newQuantityUom?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal old_quantity_uom = 11
     */
    oldQuantityUom?: Decimal;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 12
     */
    uomSnapshot?: LedgerEntry_UomSnapshot;
    /**
     * @generated from protobuf field: bool is_non_stock = 13
     */
    isNonStock: boolean;
}
/**
 * @generated from protobuf enum rd.ledger.LedgerEntry.InventoryCount.Subtype
 */
export enum LedgerEntry_InventoryCount_Subtype {
    /**
     * @generated from protobuf enum value: SUBTYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * primary: on hand
     * new_quantity>old_quantity:  debit on hand, credit expense
     * else:                       credit on hand, debit expense
     *
     * @generated from protobuf enum value: SUBTYPE_COUNT = 1;
     */
    COUNT = 1,
    /**
     * primary: on hand
     * new_quantity>old_quantity:  debit on hand, credit expense
     * else:                       credit on hand, debit expense
     *
     * @generated from protobuf enum value: SUBTYPE_MANUAL_COUNT = 2;
     */
    MANUAL_COUNT = 2,
    /**
     * primary: on hand
     * new_quantity>old_quantity:  debit on hand, credit expense
     * else:                       credit on hand, debit expense
     *
     * @generated from protobuf enum value: SUBTYPE_MANUAL_INITIALIZATION = 3;
     */
    MANUAL_INITIALIZATION = 3
}
/**
 * @generated from protobuf message rd.ledger.LedgerEntry.InventoryCostEdit
 */
export interface LedgerEntry_InventoryCostEdit {
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.InventoryCostEdit.Subtype subtype = 1
     */
    subtype: LedgerEntry_InventoryCostEdit_Subtype;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney new_cost = 2
     */
    newCost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney old_cost = 3
     */
    oldCost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 4
     */
    saleId?: UUID; // sale/return id for sales/returns
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_product_id = 5
     */
    saleProductId?: UUID; // sale/return product id for sales/returns
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_shipment_id = 7
     */
    orderShipmentId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_product_id = 9
     */
    orderProductId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID returned_from_sale_product_id = 10
     */
    returnedFromSaleProductId?: UUID; // sold sale product id
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID returned_from_sale_id = 11
     */
    returnedFromSaleId?: UUID; // sold sale id
    /**
     * @generated from protobuf field: bool is_special_order = 12
     */
    isSpecialOrder: boolean; // non-stock inventory accounting
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_v2 = 13
     */
    quantityV2?: Decimal;
    /**
     * Quantity with Unit of Measure information
     *
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 14
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_uom = 15
     */
    quantityUom?: Decimal;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 16
     */
    uomSnapshot?: LedgerEntry_UomSnapshot;
    /**
     * @generated from protobuf field: bool is_non_stock = 17
     */
    isNonStock: boolean;
}
/**
 * @generated from protobuf enum rd.ledger.LedgerEntry.InventoryCostEdit.Subtype
 */
export enum LedgerEntry_InventoryCostEdit_Subtype {
    /**
     * @generated from protobuf enum value: SUBTYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * primary: on hand
     * new_cost>old_cost: credit on hand, debit cogs
     * else:              debit on hand, credit cogs
     *
     * @generated from protobuf enum value: SUBTYPE_SALE = 1;
     */
    SALE = 1,
    /**
     * primary: on hand
     * new_cost>old_cost: debit on hand, credit expense transfers
     * else:              credit on hand, debit expense transfers
     *
     * @generated from protobuf enum value: SUBTYPE_SALE_RETURN = 2;
     */
    SALE_RETURN = 2,
    /**
     * primary: cogs
     * new_cost>old_cost:  debit expense transfers, credit cogs
     * else:               credit expense transfers, debit cogs
     *
     * @generated from protobuf enum value: SUBTYPE_SALE_RETURN_ACK = 3;
     */
    SALE_RETURN_ACK = 3,
    /**
     * primary: on hand
     * new_cost>old_cost:  debit on hand, credit liability accounts payable
     * else:               credit on hand, debit liability accounts payable
     *
     * @generated from protobuf enum value: SUBTYPE_SHIPMENT = 4;
     */
    SHIPMENT = 4,
    /**
     * primary: on hand
     * new_cost>old_cost:  credit on hand, debit liability accounts payable
     * else:               debit on hand, credit liability accounts payable
     *
     * @generated from protobuf enum value: SUBTYPE_SHIPMENT_RETURN = 5;
     */
    SHIPMENT_RETURN = 5,
    /**
     * primary: on hand
     * new_cost>old_cost:  debit on hand, credit cogs
     * else:               credit on hand, debit cogs
     *
     * @generated from protobuf enum value: SUBTYPE_UNLINKED_SALE_RETURN = 6;
     */
    UNLINKED_SALE_RETURN = 6,
    /**
     * primary: on hand
     * new_cost>old_cost:  debit on hand, credit cogs
     * else:               credit on hand, debit cogs
     *
     * @generated from protobuf enum value: SUBTYPE_SALE_ACK = 7;
     */
    SALE_ACK = 7,
    /**
     * @generated from protobuf enum value: SUBTYPE_UNLINKED_SALE_RETURN_ACK = 8;
     */
    UNLINKED_SALE_RETURN_ACK = 8
}
/**
 * InventoryMetadata provides additional running balance data for inventory ledger entries.
 * This is intended to be an eventually consistent and replayable data source rather
 * than a direct source of truth.
 *
 * @generated from protobuf message rd.ledger.LedgerEntry.InventoryMetadata
 */
export interface LedgerEntry_InventoryMetadata {
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney average_cost = 1
     */
    averageCost?: FractionalMoney;
    /**
     * @generated from protobuf field: map<string, rd.proto.decimal.Decimal> on_hand_inventories_by_location_id_v2 = 5
     */
    onHandInventoriesByLocationIdV2: {
        [key: string]: Decimal;
    };
    /**
     * @generated from protobuf field: map<string, rd.proto.decimal.Decimal> on_order_inventories_by_location_id_v2 = 6
     */
    onOrderInventoriesByLocationIdV2: {
        [key: string]: Decimal;
    };
    /**
     * @generated from protobuf field: map<string, rd.proto.decimal.Decimal> committed_inventories_by_location_id_v2 = 7
     */
    committedInventoriesByLocationIdV2: {
        [key: string]: Decimal;
    };
}
/**
 * DepositPurchases are a claim on a special order product.
 *
 * @generated from protobuf message rd.ledger.LedgerEntry.DepositPurchase
 */
export interface LedgerEntry_DepositPurchase {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 1
     */
    saleId?: UUID;
}
/**
 * DepositRedemptions are a forfeited claim on a special order product.
 *
 * @generated from protobuf message rd.ledger.LedgerEntry.DepositRedemption
 */
export interface LedgerEntry_DepositRedemption {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID deposit_purchase_ledger_entry_id = 1
     */
    depositPurchaseLedgerEntryId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 2
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID purchase_ledger_entry_id = 3
     */
    purchaseLedgerEntryId?: UUID;
}
/**
 * DepositForfeiture purely represents the movement of money from Customer
 * Deposits to Forfeited Deposits.
 *
 * @generated from protobuf message rd.ledger.LedgerEntry.DepositForfeiture
 */
export interface LedgerEntry_DepositForfeiture {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID deposit_redemption_ledger_entry_id = 1
     */
    depositRedemptionLedgerEntryId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 2
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID deposit_purchase_ledger_entry_id = 3
     */
    depositPurchaseLedgerEntryId?: UUID; // undefined. needs to be backfilled
}
/**
 * FinancingCharge represents a finance charge that was assessed on a customer's outstanding
 * balance. The charge is calculated based on the assessment rate applied to the outstanding
 * balance, with possible adjustments for minimum charge fees. It is recorded as a ledger entry
 * with a positive amount as it increases the customer's balance.
 *
 * @generated from protobuf message rd.ledger.LedgerEntry.FinancingCharge
 */
export interface LedgerEntry_FinancingCharge {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string; // user-friendly identifier
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> assessed_purchases_by_id = 2
     */
    assessedPurchasesById: {
        [key: string]: Money;
    }; // map of outstanding purchases that were assessed
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> assessed_finance_charges_by_id = 3
     */
    assessedFinanceChargesById: {
        [key: string]: Money;
    }; // map of oustanding finance charges that were assessed
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal assessment_rate = 4
     */
    assessmentRate?: Decimal; // prevailing finance charge rate at time of assessment
    /**
     * @generated from protobuf field: rd.proto.money.Money adjustment_amount = 5
     */
    adjustmentAmount?: Money; // adjustment made to the finance charge due to prevailing minimum charge fee
}
/**
 * ReceivablesMetadata provides additional running balance data for receivables ledger entries.
 * This is intended to be an eventually consistent and replayable data source rather
 * than a direct source of truth.
 *
 * @generated from protobuf message rd.ledger.LedgerEntry.ReceivablesMetadata
 */
export interface LedgerEntry_ReceivablesMetadata {
    /**
     * Customer ID can be either the parent customer ID or the job customer ID.
     *
     * @generated from protobuf field: map<string, rd.proto.money.Money> running_balance_by_customer_id = 1
     */
    runningBalanceByCustomerId: {
        [key: string]: Money;
    };
}
/**
 * @generated from protobuf message rd.ledger.LedgerEntry.GiftCardActivation
 */
export interface LedgerEntry_GiftCardActivation {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID gift_card_id = 1
     */
    giftCardId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 2
     */
    saleId?: UUID; // Sale where gift card was activated
    /**
     * true if the gift card was created by admin.InsertExistingGiftCards to exclude from accounting
     *
     * @generated from protobuf field: bool non_sale_gift_card_activation = 4
     */
    nonSaleGiftCardActivation: boolean;
}
/**
 * @generated from protobuf message rd.ledger.LedgerEntry.GiftCardDeactivation
 */
export interface LedgerEntry_GiftCardDeactivation {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID gift_card_activation_ledger_entry_id = 1
     */
    giftCardActivationLedgerEntryId?: UUID;
}
/**
 * @generated from protobuf message rd.ledger.LedgerEntry.LoyaltyPoints
 */
export interface LedgerEntry_LoyaltyPoints {
    /**
     * @generated from protobuf field: int64 points = 1
     */
    points: bigint;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.LoyaltyPoints.Subtype subtype = 2
     */
    subtype: LedgerEntry_LoyaltyPoints_Subtype;
    /**
     * SUBTYPE_EARN: points earned per sale product
     * SUBTYPE_REDEMPTION: points spent per sale product
     * SUBTYPE_CLAW_BACK: points clawed back per returned sale product
     *
     * @generated from protobuf field: map<string, int64> points_per_sale_product_id = 3
     */
    pointsPerSaleProductId: {
        [key: string]: bigint;
    };
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID source_le_id = 4
     */
    sourceLeId?: UUID; // set for redemption/claw back/expiration/deduction
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 5
     */
    saleId?: UUID; // set for earn/redemption/claw back
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID reward_id = 6
     */
    rewardId?: UUID; // set for redemption
}
/**
 * @generated from protobuf enum rd.ledger.LedgerEntry.LoyaltyPoints.Subtype
 */
export enum LedgerEntry_LoyaltyPoints_Subtype {
    /**
     * @generated from protobuf enum value: SUBTYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: SUBTYPE_EARN = 1;
     */
    EARN = 1,
    /**
     * @generated from protobuf enum value: SUBTYPE_REDEMPTION = 2;
     */
    REDEMPTION = 2,
    /**
     * @generated from protobuf enum value: SUBTYPE_CLAW_BACK = 3;
     */
    CLAW_BACK = 3,
    /**
     * @generated from protobuf enum value: SUBTYPE_GRANT = 4;
     */
    GRANT = 4,
    /**
     * @generated from protobuf enum value: SUBTYPE_DEDUCTION = 5;
     */
    DEDUCTION = 5,
    /**
     * @generated from protobuf enum value: SUBTYPE_EXPIRATION = 6;
     */
    EXPIRATION = 6
}
/**
 * @generated from protobuf enum rd.ledger.LedgerEntry.Type
 */
export enum LedgerEntry_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_PURCHASE = 1;
     */
    PURCHASE = 1,
    /**
     * @generated from protobuf enum value: TYPE_RETURN = 2;
     */
    RETURN = 2,
    /**
     * @generated from protobuf enum value: TYPE_PAYMENT = 3;
     */
    PAYMENT = 3,
    /**
     * @generated from protobuf enum value: TYPE_REFUND = 5;
     */
    REFUND = 5,
    /**
     * @generated from protobuf enum value: TYPE_FINANCING_CHARGE = 6;
     */
    FINANCING_CHARGE = 6,
    /**
     * @generated from protobuf enum value: TYPE_PETTY_CASH = 7;
     */
    PETTY_CASH = 7,
    /**
     * @generated from protobuf enum value: TYPE_CLOSE_OUT = 8;
     */
    CLOSE_OUT = 8,
    /**
     * @generated from protobuf enum value: TYPE_DISCOUNT = 10;
     */
    DISCOUNT = 10,
    /**
     * @generated from protobuf enum value: TYPE_REVERSE_DISCOUNT = 11;
     */
    REVERSE_DISCOUNT = 11,
    /**
     * New inventory ledger entries
     * Make sure to update the inventoryLedgerTypes in inventory_ledger.go if this changes
     *
     * @generated from protobuf enum value: TYPE_INVENTORY_HOLD = 30;
     */
    INVENTORY_HOLD = 30,
    /**
     * @generated from protobuf enum value: TYPE_INVENTORY_ORDER = 31;
     */
    INVENTORY_ORDER = 31,
    /**
     * @generated from protobuf enum value: TYPE_INVENTORY_RECEIPT = 32;
     */
    INVENTORY_RECEIPT = 32,
    /**
     * @generated from protobuf enum value: TYPE_INVENTORY_RELEASE = 33;
     */
    INVENTORY_RELEASE = 33,
    /**
     * @generated from protobuf enum value: TYPE_INVENTORY_COUNT = 34;
     */
    INVENTORY_COUNT = 34,
    /**
     * @generated from protobuf enum value: TYPE_INVENTORY_COST_EDIT = 35;
     */
    INVENTORY_COST_EDIT = 35,
    /**
     * Special-order related ledger entries
     *
     * @generated from protobuf enum value: TYPE_DEPOSIT_PURCHASE = 36;
     */
    DEPOSIT_PURCHASE = 36,
    /**
     * @generated from protobuf enum value: TYPE_DEPOSIT_REDEMPTION = 37;
     */
    DEPOSIT_REDEMPTION = 37,
    /**
     * @generated from protobuf enum value: TYPE_DEPOSIT_FORFEITURE = 38;
     */
    DEPOSIT_FORFEITURE = 38,
    /**
     * Gift cards
     *
     * non-positive
     *
     * @generated from protobuf enum value: TYPE_GIFT_CARD_ACTIVATION = 39;
     */
    GIFT_CARD_ACTIVATION = 39,
    /**
     * non-negative
     *
     * @generated from protobuf enum value: TYPE_GIFT_CARD_DEACTIVATION = 40;
     */
    GIFT_CARD_DEACTIVATION = 40,
    /**
     * Loyalty points
     *
     * @generated from protobuf enum value: TYPE_LOYALTY_PTS_ADD = 41;
     */
    LOYALTY_PTS_ADD = 41,
    /**
     * @generated from protobuf enum value: TYPE_LOYALTY_PTS_REMOVE = 42;
     */
    LOYALTY_PTS_REMOVE = 42
}
/**
 * @generated from protobuf message rd.ledger.LedgerMethods
 */
export interface LedgerMethods {
    /**
     * @generated from protobuf field: repeated rd.ledger.LedgerMethods.Method methods = 1
     */
    methods: LedgerMethods_Method[];
}
/**
 * @generated from protobuf message rd.ledger.LedgerMethods.Method
 */
export interface LedgerMethods_Method {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID method_id = 1
     */
    methodId?: UUID;
    /**
     * @generated from protobuf field: rd.company.tender.Method.Type method_type = 2
     */
    methodType: Method_Type;
    /**
     * @generated from protobuf field: string method_name = 3
     */
    methodName: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money amount = 4
     */
    amount?: Money;
    /**
     * @generated from protobuf field: string check_number = 5
     */
    checkNumber: string;
    /**
     * @generated from protobuf field: rd.payments.Card card = 6
     */
    card?: Card;
    /**
     * @generated from protobuf field: rd.proto.money.Money cash_received = 7
     */
    cashReceived?: Money;
    /**
     * @generated from protobuf field: string custom_note = 8
     */
    customNote: string;
    /**
     * @generated from protobuf field: rd.payments.BankPaymentMethod bank_payment_method = 9
     */
    bankPaymentMethod?: BankPaymentMethod;
    /**
     * @generated from protobuf field: rd.proto.money.Money surcharge = 10
     */
    surcharge?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money surcharge_tax = 11
     */
    surchargeTax?: Money;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp accounted_at = 12
     */
    accountedAt?: Timestamp;
    /**
     * @generated from protobuf field: string gift_card_number_last_4 = 13
     */
    giftCardNumberLast4: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID gift_card_id = 14
     */
    giftCardId?: UUID;
    /**
     * @generated from protobuf field: string display_name = 15
     */
    displayName: string;
    /**
     * @generated from protobuf field: bool is_interac = 16
     */
    isInterac: boolean;
}
/**
 * @generated from protobuf message rd.ledger.ReceiptPurchaseMethods
 */
export interface ReceiptPurchaseMethods {
    /**
     * @generated from protobuf field: repeated rd.ledger.ReceiptPurchaseMethods.Method methods = 1
     */
    methods: ReceiptPurchaseMethods_Method[];
}
/**
 * @generated from protobuf message rd.ledger.ReceiptPurchaseMethods.Method
 */
export interface ReceiptPurchaseMethods_Method {
    /**
     * @generated from protobuf field: string method = 1
     */
    method: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money amount = 2
     */
    amount?: Money;
}
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry$Type extends MessageType<LedgerEntry> {
    constructor() {
        super("rd.ledger.LedgerEntry", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "customer_id", kind: "message", T: () => UUID },
            { no: 6, name: "created_by", kind: "message", T: () => User },
            { no: 7, name: "amount", kind: "message", T: () => Money },
            { no: 8, name: "type", kind: "enum", T: () => ["rd.ledger.LedgerEntry.Type", LedgerEntry_Type, "TYPE_"] },
            { no: 9, name: "purchase", kind: "message", T: () => LedgerEntry_Purchase },
            { no: 10, name: "return", kind: "message", T: () => LedgerEntry_Return },
            { no: 11, name: "payment", kind: "message", T: () => LedgerEntry_Payment },
            { no: 13, name: "refund", kind: "message", T: () => LedgerEntry_Refund },
            { no: 14, name: "location_id", kind: "message", T: () => UUID },
            { no: 15, name: "petty_cash", kind: "message", T: () => LedgerEntry_PettyCash },
            { no: 16, name: "close_out", kind: "message", T: () => LedgerEntry_CloseOut },
            { no: 17, name: "allocation", kind: "message", T: () => LedgerEntry_Allocation },
            { no: 18, name: "discount", kind: "message", T: () => LedgerEntry_Discount },
            { no: 19, name: "reverse_discount", kind: "message", T: () => LedgerEntry_ReverseDiscount },
            { no: 20, name: "product_id", kind: "message", T: () => UUID },
            { no: 21, name: "job_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 39, name: "debug_notes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 40, name: "inventory_hold", kind: "message", T: () => LedgerEntry_InventoryHold },
            { no: 41, name: "inventory_order", kind: "message", T: () => LedgerEntry_InventoryOrder },
            { no: 42, name: "inventory_receipt", kind: "message", T: () => LedgerEntry_InventoryReceipt },
            { no: 43, name: "inventory_release", kind: "message", T: () => LedgerEntry_InventoryRelease },
            { no: 44, name: "inventory_count", kind: "message", T: () => LedgerEntry_InventoryCount },
            { no: 45, name: "inventory_cost_edit", kind: "message", T: () => LedgerEntry_InventoryCostEdit },
            { no: 46, name: "inventory_metadata", kind: "message", T: () => LedgerEntry_InventoryMetadata },
            { no: 48, name: "deposit_purchase", kind: "message", T: () => LedgerEntry_DepositPurchase },
            { no: 49, name: "deposit_redemption", kind: "message", T: () => LedgerEntry_DepositRedemption },
            { no: 50, name: "deposit_forfeiture", kind: "message", T: () => LedgerEntry_DepositForfeiture },
            { no: 51, name: "financing_charge", kind: "message", T: () => LedgerEntry_FinancingCharge },
            { no: 52, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 53, name: "updated_by", kind: "message", T: () => User },
            { no: 54, name: "accounted_at", kind: "message", T: () => Timestamp },
            { no: 55, name: "is_reversed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 56, name: "reversed_at", kind: "message", T: () => Timestamp },
            { no: 57, name: "reversed_by", kind: "message", T: () => User },
            { no: 58, name: "is_reversal", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 59, name: "reversed_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 60, name: "is_replacement", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 61, name: "replaced_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 62, name: "original_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 63, name: "active_replacement_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 64, name: "receivables_metadata", kind: "message", T: () => LedgerEntry_ReceivablesMetadata },
            { no: 65, name: "gift_card_activation", kind: "message", T: () => LedgerEntry_GiftCardActivation },
            { no: 66, name: "gift_card_deactivation", kind: "message", T: () => LedgerEntry_GiftCardDeactivation },
            { no: 67, name: "loyalty_points", kind: "message", T: () => LedgerEntry_LoyaltyPoints }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry>): LedgerEntry {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.jobIds = [];
        message.debugNotes = [];
        message.isReversed = false;
        message.isReversal = false;
        message.isReplacement = false;
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry): LedgerEntry {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 5:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.user.User created_by */ 6:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.proto.money.Money amount */ 7:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* rd.ledger.LedgerEntry.Type type */ 8:
                    message.type = reader.int32();
                    break;
                case /* rd.ledger.LedgerEntry.Purchase purchase */ 9:
                    message.purchase = LedgerEntry_Purchase.internalBinaryRead(reader, reader.uint32(), options, message.purchase);
                    break;
                case /* rd.ledger.LedgerEntry.Return return */ 10:
                    message.return = LedgerEntry_Return.internalBinaryRead(reader, reader.uint32(), options, message.return);
                    break;
                case /* rd.ledger.LedgerEntry.Payment payment */ 11:
                    message.payment = LedgerEntry_Payment.internalBinaryRead(reader, reader.uint32(), options, message.payment);
                    break;
                case /* rd.ledger.LedgerEntry.Refund refund */ 13:
                    message.refund = LedgerEntry_Refund.internalBinaryRead(reader, reader.uint32(), options, message.refund);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 14:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.ledger.LedgerEntry.PettyCash petty_cash */ 15:
                    message.pettyCash = LedgerEntry_PettyCash.internalBinaryRead(reader, reader.uint32(), options, message.pettyCash);
                    break;
                case /* rd.ledger.LedgerEntry.CloseOut close_out */ 16:
                    message.closeOut = LedgerEntry_CloseOut.internalBinaryRead(reader, reader.uint32(), options, message.closeOut);
                    break;
                case /* rd.ledger.LedgerEntry.Allocation allocation */ 17:
                    message.allocation = LedgerEntry_Allocation.internalBinaryRead(reader, reader.uint32(), options, message.allocation);
                    break;
                case /* rd.ledger.LedgerEntry.Discount discount */ 18:
                    message.discount = LedgerEntry_Discount.internalBinaryRead(reader, reader.uint32(), options, message.discount);
                    break;
                case /* rd.ledger.LedgerEntry.ReverseDiscount reverse_discount */ 19:
                    message.reverseDiscount = LedgerEntry_ReverseDiscount.internalBinaryRead(reader, reader.uint32(), options, message.reverseDiscount);
                    break;
                case /* rd.proto.uuid.UUID product_id */ 20:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* repeated rd.proto.uuid.UUID job_ids */ 21:
                    message.jobIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string debug_notes */ 39:
                    message.debugNotes.push(reader.string());
                    break;
                case /* rd.ledger.LedgerEntry.InventoryHold inventory_hold */ 40:
                    message.inventoryHold = LedgerEntry_InventoryHold.internalBinaryRead(reader, reader.uint32(), options, message.inventoryHold);
                    break;
                case /* rd.ledger.LedgerEntry.InventoryOrder inventory_order */ 41:
                    message.inventoryOrder = LedgerEntry_InventoryOrder.internalBinaryRead(reader, reader.uint32(), options, message.inventoryOrder);
                    break;
                case /* rd.ledger.LedgerEntry.InventoryReceipt inventory_receipt */ 42:
                    message.inventoryReceipt = LedgerEntry_InventoryReceipt.internalBinaryRead(reader, reader.uint32(), options, message.inventoryReceipt);
                    break;
                case /* rd.ledger.LedgerEntry.InventoryRelease inventory_release */ 43:
                    message.inventoryRelease = LedgerEntry_InventoryRelease.internalBinaryRead(reader, reader.uint32(), options, message.inventoryRelease);
                    break;
                case /* rd.ledger.LedgerEntry.InventoryCount inventory_count */ 44:
                    message.inventoryCount = LedgerEntry_InventoryCount.internalBinaryRead(reader, reader.uint32(), options, message.inventoryCount);
                    break;
                case /* rd.ledger.LedgerEntry.InventoryCostEdit inventory_cost_edit */ 45:
                    message.inventoryCostEdit = LedgerEntry_InventoryCostEdit.internalBinaryRead(reader, reader.uint32(), options, message.inventoryCostEdit);
                    break;
                case /* rd.ledger.LedgerEntry.InventoryMetadata inventory_metadata */ 46:
                    message.inventoryMetadata = LedgerEntry_InventoryMetadata.internalBinaryRead(reader, reader.uint32(), options, message.inventoryMetadata);
                    break;
                case /* rd.ledger.LedgerEntry.DepositPurchase deposit_purchase */ 48:
                    message.depositPurchase = LedgerEntry_DepositPurchase.internalBinaryRead(reader, reader.uint32(), options, message.depositPurchase);
                    break;
                case /* rd.ledger.LedgerEntry.DepositRedemption deposit_redemption */ 49:
                    message.depositRedemption = LedgerEntry_DepositRedemption.internalBinaryRead(reader, reader.uint32(), options, message.depositRedemption);
                    break;
                case /* rd.ledger.LedgerEntry.DepositForfeiture deposit_forfeiture */ 50:
                    message.depositForfeiture = LedgerEntry_DepositForfeiture.internalBinaryRead(reader, reader.uint32(), options, message.depositForfeiture);
                    break;
                case /* rd.ledger.LedgerEntry.FinancingCharge financing_charge */ 51:
                    message.financingCharge = LedgerEntry_FinancingCharge.internalBinaryRead(reader, reader.uint32(), options, message.financingCharge);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 52:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User updated_by */ 53:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* google.protobuf.Timestamp accounted_at */ 54:
                    message.accountedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.accountedAt);
                    break;
                case /* bool is_reversed */ 55:
                    message.isReversed = reader.bool();
                    break;
                case /* google.protobuf.Timestamp reversed_at */ 56:
                    message.reversedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.reversedAt);
                    break;
                case /* rd.user.User reversed_by */ 57:
                    message.reversedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.reversedBy);
                    break;
                case /* bool is_reversal */ 58:
                    message.isReversal = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID reversed_ledger_entry_id */ 59:
                    message.reversedLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.reversedLedgerEntryId);
                    break;
                case /* bool is_replacement */ 60:
                    message.isReplacement = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID replaced_ledger_entry_id */ 61:
                    message.replacedLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.replacedLedgerEntryId);
                    break;
                case /* rd.proto.uuid.UUID original_ledger_entry_id */ 62:
                    message.originalLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.originalLedgerEntryId);
                    break;
                case /* rd.proto.uuid.UUID active_replacement_ledger_entry_id */ 63:
                    message.activeReplacementLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.activeReplacementLedgerEntryId);
                    break;
                case /* rd.ledger.LedgerEntry.ReceivablesMetadata receivables_metadata */ 64:
                    message.receivablesMetadata = LedgerEntry_ReceivablesMetadata.internalBinaryRead(reader, reader.uint32(), options, message.receivablesMetadata);
                    break;
                case /* rd.ledger.LedgerEntry.GiftCardActivation gift_card_activation */ 65:
                    message.giftCardActivation = LedgerEntry_GiftCardActivation.internalBinaryRead(reader, reader.uint32(), options, message.giftCardActivation);
                    break;
                case /* rd.ledger.LedgerEntry.GiftCardDeactivation gift_card_deactivation */ 66:
                    message.giftCardDeactivation = LedgerEntry_GiftCardDeactivation.internalBinaryRead(reader, reader.uint32(), options, message.giftCardDeactivation);
                    break;
                case /* rd.ledger.LedgerEntry.LoyaltyPoints loyalty_points */ 67:
                    message.loyaltyPoints = LedgerEntry_LoyaltyPoints.internalBinaryRead(reader, reader.uint32(), options, message.loyaltyPoints);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 5; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 6; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money amount = 7; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.Type type = 8; */
        if (message.type !== 0)
            writer.tag(8, WireType.Varint).int32(message.type);
        /* rd.ledger.LedgerEntry.Purchase purchase = 9; */
        if (message.purchase)
            LedgerEntry_Purchase.internalBinaryWrite(message.purchase, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.Return return = 10; */
        if (message.return)
            LedgerEntry_Return.internalBinaryWrite(message.return, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.Payment payment = 11; */
        if (message.payment)
            LedgerEntry_Payment.internalBinaryWrite(message.payment, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.Refund refund = 13; */
        if (message.refund)
            LedgerEntry_Refund.internalBinaryWrite(message.refund, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 14; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.PettyCash petty_cash = 15; */
        if (message.pettyCash)
            LedgerEntry_PettyCash.internalBinaryWrite(message.pettyCash, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.CloseOut close_out = 16; */
        if (message.closeOut)
            LedgerEntry_CloseOut.internalBinaryWrite(message.closeOut, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.Allocation allocation = 17; */
        if (message.allocation)
            LedgerEntry_Allocation.internalBinaryWrite(message.allocation, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.Discount discount = 18; */
        if (message.discount)
            LedgerEntry_Discount.internalBinaryWrite(message.discount, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.ReverseDiscount reverse_discount = 19; */
        if (message.reverseDiscount)
            LedgerEntry_ReverseDiscount.internalBinaryWrite(message.reverseDiscount, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID product_id = 20; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID job_ids = 21; */
        for (let i = 0; i < message.jobIds.length; i++)
            UUID.internalBinaryWrite(message.jobIds[i], writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* repeated string debug_notes = 39; */
        for (let i = 0; i < message.debugNotes.length; i++)
            writer.tag(39, WireType.LengthDelimited).string(message.debugNotes[i]);
        /* rd.ledger.LedgerEntry.InventoryHold inventory_hold = 40; */
        if (message.inventoryHold)
            LedgerEntry_InventoryHold.internalBinaryWrite(message.inventoryHold, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.InventoryOrder inventory_order = 41; */
        if (message.inventoryOrder)
            LedgerEntry_InventoryOrder.internalBinaryWrite(message.inventoryOrder, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.InventoryReceipt inventory_receipt = 42; */
        if (message.inventoryReceipt)
            LedgerEntry_InventoryReceipt.internalBinaryWrite(message.inventoryReceipt, writer.tag(42, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.InventoryRelease inventory_release = 43; */
        if (message.inventoryRelease)
            LedgerEntry_InventoryRelease.internalBinaryWrite(message.inventoryRelease, writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.InventoryCount inventory_count = 44; */
        if (message.inventoryCount)
            LedgerEntry_InventoryCount.internalBinaryWrite(message.inventoryCount, writer.tag(44, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.InventoryCostEdit inventory_cost_edit = 45; */
        if (message.inventoryCostEdit)
            LedgerEntry_InventoryCostEdit.internalBinaryWrite(message.inventoryCostEdit, writer.tag(45, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.InventoryMetadata inventory_metadata = 46; */
        if (message.inventoryMetadata)
            LedgerEntry_InventoryMetadata.internalBinaryWrite(message.inventoryMetadata, writer.tag(46, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.DepositPurchase deposit_purchase = 48; */
        if (message.depositPurchase)
            LedgerEntry_DepositPurchase.internalBinaryWrite(message.depositPurchase, writer.tag(48, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.DepositRedemption deposit_redemption = 49; */
        if (message.depositRedemption)
            LedgerEntry_DepositRedemption.internalBinaryWrite(message.depositRedemption, writer.tag(49, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.DepositForfeiture deposit_forfeiture = 50; */
        if (message.depositForfeiture)
            LedgerEntry_DepositForfeiture.internalBinaryWrite(message.depositForfeiture, writer.tag(50, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.FinancingCharge financing_charge = 51; */
        if (message.financingCharge)
            LedgerEntry_FinancingCharge.internalBinaryWrite(message.financingCharge, writer.tag(51, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 52; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(52, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 53; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(53, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp accounted_at = 54; */
        if (message.accountedAt)
            Timestamp.internalBinaryWrite(message.accountedAt, writer.tag(54, WireType.LengthDelimited).fork(), options).join();
        /* bool is_reversed = 55; */
        if (message.isReversed !== false)
            writer.tag(55, WireType.Varint).bool(message.isReversed);
        /* google.protobuf.Timestamp reversed_at = 56; */
        if (message.reversedAt)
            Timestamp.internalBinaryWrite(message.reversedAt, writer.tag(56, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User reversed_by = 57; */
        if (message.reversedBy)
            User.internalBinaryWrite(message.reversedBy, writer.tag(57, WireType.LengthDelimited).fork(), options).join();
        /* bool is_reversal = 58; */
        if (message.isReversal !== false)
            writer.tag(58, WireType.Varint).bool(message.isReversal);
        /* rd.proto.uuid.UUID reversed_ledger_entry_id = 59; */
        if (message.reversedLedgerEntryId)
            UUID.internalBinaryWrite(message.reversedLedgerEntryId, writer.tag(59, WireType.LengthDelimited).fork(), options).join();
        /* bool is_replacement = 60; */
        if (message.isReplacement !== false)
            writer.tag(60, WireType.Varint).bool(message.isReplacement);
        /* rd.proto.uuid.UUID replaced_ledger_entry_id = 61; */
        if (message.replacedLedgerEntryId)
            UUID.internalBinaryWrite(message.replacedLedgerEntryId, writer.tag(61, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID original_ledger_entry_id = 62; */
        if (message.originalLedgerEntryId)
            UUID.internalBinaryWrite(message.originalLedgerEntryId, writer.tag(62, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID active_replacement_ledger_entry_id = 63; */
        if (message.activeReplacementLedgerEntryId)
            UUID.internalBinaryWrite(message.activeReplacementLedgerEntryId, writer.tag(63, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.ReceivablesMetadata receivables_metadata = 64; */
        if (message.receivablesMetadata)
            LedgerEntry_ReceivablesMetadata.internalBinaryWrite(message.receivablesMetadata, writer.tag(64, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.GiftCardActivation gift_card_activation = 65; */
        if (message.giftCardActivation)
            LedgerEntry_GiftCardActivation.internalBinaryWrite(message.giftCardActivation, writer.tag(65, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.GiftCardDeactivation gift_card_deactivation = 66; */
        if (message.giftCardDeactivation)
            LedgerEntry_GiftCardDeactivation.internalBinaryWrite(message.giftCardDeactivation, writer.tag(66, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.LoyaltyPoints loyalty_points = 67; */
        if (message.loyaltyPoints)
            LedgerEntry_LoyaltyPoints.internalBinaryWrite(message.loyaltyPoints, writer.tag(67, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry
 */
export const LedgerEntry = new LedgerEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_PotentialDiscount$Type extends MessageType<LedgerEntry_PotentialDiscount> {
    constructor() {
        super("rd.ledger.LedgerEntry.PotentialDiscount", [
            { no: 1, name: "type", kind: "enum", T: () => ["rd.ledger.LedgerEntry.PotentialDiscount.Type", LedgerEntry_PotentialDiscount_Type] },
            { no: 3, name: "rate", kind: "message", T: () => Decimal },
            { no: 4, name: "term_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "expires_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_PotentialDiscount>): LedgerEntry_PotentialDiscount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.termName = "";
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_PotentialDiscount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_PotentialDiscount): LedgerEntry_PotentialDiscount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.ledger.LedgerEntry.PotentialDiscount.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* rd.proto.decimal.Decimal rate */ 3:
                    message.rate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.rate);
                    break;
                case /* string term_name */ 4:
                    message.termName = reader.string();
                    break;
                case /* google.protobuf.Timestamp expires_at */ 5:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_PotentialDiscount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.ledger.LedgerEntry.PotentialDiscount.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* rd.proto.decimal.Decimal rate = 3; */
        if (message.rate)
            Decimal.internalBinaryWrite(message.rate, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string term_name = 4; */
        if (message.termName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.termName);
        /* google.protobuf.Timestamp expires_at = 5; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.PotentialDiscount
 */
export const LedgerEntry_PotentialDiscount = new LedgerEntry_PotentialDiscount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_Purchase$Type extends MessageType<LedgerEntry_Purchase> {
    constructor() {
        super("rd.ledger.LedgerEntry.Purchase", [
            { no: 1, name: "sale_id", kind: "message", T: () => UUID },
            { no: 2, name: "due_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "potential_discounts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LedgerEntry_PotentialDiscount }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_Purchase>): LedgerEntry_Purchase {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.potentialDiscounts = [];
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_Purchase>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_Purchase): LedgerEntry_Purchase {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID sale_id */ 1:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* google.protobuf.Timestamp due_at */ 2:
                    message.dueAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.dueAt);
                    break;
                case /* repeated rd.ledger.LedgerEntry.PotentialDiscount potential_discounts */ 3:
                    message.potentialDiscounts.push(LedgerEntry_PotentialDiscount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_Purchase, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID sale_id = 1; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp due_at = 2; */
        if (message.dueAt)
            Timestamp.internalBinaryWrite(message.dueAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.ledger.LedgerEntry.PotentialDiscount potential_discounts = 3; */
        for (let i = 0; i < message.potentialDiscounts.length; i++)
            LedgerEntry_PotentialDiscount.internalBinaryWrite(message.potentialDiscounts[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.Purchase
 */
export const LedgerEntry_Purchase = new LedgerEntry_Purchase$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_Return$Type extends MessageType<LedgerEntry_Return> {
    constructor() {
        super("rd.ledger.LedgerEntry.Return", [
            { no: 1, name: "purchase_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 2, name: "returned_from_sale_id", kind: "message", T: () => UUID },
            { no: 4, name: "sale_id", kind: "message", T: () => UUID },
            { no: 5, name: "is_unallocated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "unallocated_credits_added", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_Return>): LedgerEntry_Return {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isUnallocated = false;
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_Return>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_Return): LedgerEntry_Return {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID purchase_ledger_entry_id */ 1:
                    message.purchaseLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.purchaseLedgerEntryId);
                    break;
                case /* rd.proto.uuid.UUID returned_from_sale_id */ 2:
                    message.returnedFromSaleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.returnedFromSaleId);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 4:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* bool is_unallocated */ 5:
                    message.isUnallocated = reader.bool();
                    break;
                case /* rd.proto.money.Money unallocated_credits_added */ 6:
                    message.unallocatedCreditsAdded = Money.internalBinaryRead(reader, reader.uint32(), options, message.unallocatedCreditsAdded);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_Return, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID purchase_ledger_entry_id = 1; */
        if (message.purchaseLedgerEntryId)
            UUID.internalBinaryWrite(message.purchaseLedgerEntryId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID returned_from_sale_id = 2; */
        if (message.returnedFromSaleId)
            UUID.internalBinaryWrite(message.returnedFromSaleId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 4; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool is_unallocated = 5; */
        if (message.isUnallocated !== false)
            writer.tag(5, WireType.Varint).bool(message.isUnallocated);
        /* rd.proto.money.Money unallocated_credits_added = 6; */
        if (message.unallocatedCreditsAdded)
            Money.internalBinaryWrite(message.unallocatedCreditsAdded, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.Return
 */
export const LedgerEntry_Return = new LedgerEntry_Return$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_Payment$Type extends MessageType<LedgerEntry_Payment> {
    constructor() {
        super("rd.ledger.LedgerEntry.Payment", [
            { no: 2, name: "purchase_allocations_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 4, name: "cash_received", kind: "message", T: () => Money },
            { no: 5, name: "stripe_payment_intent_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "check_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "bill_payment_id", kind: "message", T: () => UUID },
            { no: 8, name: "fee", kind: "message", T: () => Money },
            { no: 9, name: "cash_register", kind: "message", T: () => CashRegister },
            { no: 10, name: "card", kind: "message", T: () => Card },
            { no: 11, name: "surcharge", kind: "message", T: () => Money },
            { no: 12, name: "surcharge_tax", kind: "message", T: () => Money },
            { no: 14, name: "finance_charge_allocations_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 15, name: "deposit_purchase_allocations_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 16, name: "unallocated_credits_added", kind: "message", T: () => Money },
            { no: 17, name: "payment_credit_allocations_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 18, name: "write_off_credit_allocations_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 19, name: "return_credit_allocations_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 20, name: "tender_method_id", kind: "message", T: () => UUID },
            { no: 21, name: "fallback_allocations_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 22, name: "should_print_receipt", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "custom_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "stripe_charge_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 25, name: "bank_payment_method", kind: "message", T: () => BankPaymentMethod },
            { no: 27, name: "gift_card_activation_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 28, name: "gift_card_number_last_4", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "is_interac", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 30, name: "surcharge_tax_by_tax_rate_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 31, name: "cash_rounding_delta", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_Payment>): LedgerEntry_Payment {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.purchaseAllocationsById = {};
        message.stripePaymentIntentId = "";
        message.checkNumber = "";
        message.financeChargeAllocationsById = {};
        message.depositPurchaseAllocationsById = {};
        message.paymentCreditAllocationsById = {};
        message.writeOffCreditAllocationsById = {};
        message.returnCreditAllocationsById = {};
        message.fallbackAllocationsById = {};
        message.shouldPrintReceipt = false;
        message.customNote = "";
        message.stripeChargeId = "";
        message.giftCardNumberLast4 = "";
        message.isInterac = false;
        message.surchargeTaxByTaxRateId = {};
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_Payment>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_Payment): LedgerEntry_Payment {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, rd.proto.money.Money> purchase_allocations_by_id */ 2:
                    this.binaryReadMap2(message.purchaseAllocationsById, reader, options);
                    break;
                case /* rd.proto.money.Money cash_received */ 4:
                    message.cashReceived = Money.internalBinaryRead(reader, reader.uint32(), options, message.cashReceived);
                    break;
                case /* string stripe_payment_intent_id */ 5:
                    message.stripePaymentIntentId = reader.string();
                    break;
                case /* string check_number */ 6:
                    message.checkNumber = reader.string();
                    break;
                case /* rd.proto.uuid.UUID bill_payment_id */ 7:
                    message.billPaymentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.billPaymentId);
                    break;
                case /* rd.proto.money.Money fee */ 8:
                    message.fee = Money.internalBinaryRead(reader, reader.uint32(), options, message.fee);
                    break;
                case /* rd.company.CashRegister cash_register */ 9:
                    message.cashRegister = CashRegister.internalBinaryRead(reader, reader.uint32(), options, message.cashRegister);
                    break;
                case /* rd.payments.Card card */ 10:
                    message.card = Card.internalBinaryRead(reader, reader.uint32(), options, message.card);
                    break;
                case /* rd.proto.money.Money surcharge */ 11:
                    message.surcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.surcharge);
                    break;
                case /* rd.proto.money.Money surcharge_tax */ 12:
                    message.surchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.surchargeTax);
                    break;
                case /* map<string, rd.proto.money.Money> finance_charge_allocations_by_id */ 14:
                    this.binaryReadMap14(message.financeChargeAllocationsById, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> deposit_purchase_allocations_by_id */ 15:
                    this.binaryReadMap15(message.depositPurchaseAllocationsById, reader, options);
                    break;
                case /* rd.proto.money.Money unallocated_credits_added */ 16:
                    message.unallocatedCreditsAdded = Money.internalBinaryRead(reader, reader.uint32(), options, message.unallocatedCreditsAdded);
                    break;
                case /* map<string, rd.proto.money.Money> payment_credit_allocations_by_id */ 17:
                    this.binaryReadMap17(message.paymentCreditAllocationsById, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> write_off_credit_allocations_by_id */ 18:
                    this.binaryReadMap18(message.writeOffCreditAllocationsById, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> return_credit_allocations_by_id */ 19:
                    this.binaryReadMap19(message.returnCreditAllocationsById, reader, options);
                    break;
                case /* rd.proto.uuid.UUID tender_method_id */ 20:
                    message.tenderMethodId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.tenderMethodId);
                    break;
                case /* map<string, rd.proto.money.Money> fallback_allocations_by_id */ 21:
                    this.binaryReadMap21(message.fallbackAllocationsById, reader, options);
                    break;
                case /* bool should_print_receipt */ 22:
                    message.shouldPrintReceipt = reader.bool();
                    break;
                case /* string custom_note */ 23:
                    message.customNote = reader.string();
                    break;
                case /* string stripe_charge_id */ 24:
                    message.stripeChargeId = reader.string();
                    break;
                case /* rd.payments.BankPaymentMethod bank_payment_method */ 25:
                    message.bankPaymentMethod = BankPaymentMethod.internalBinaryRead(reader, reader.uint32(), options, message.bankPaymentMethod);
                    break;
                case /* rd.proto.uuid.UUID gift_card_activation_ledger_entry_id */ 27:
                    message.giftCardActivationLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.giftCardActivationLedgerEntryId);
                    break;
                case /* string gift_card_number_last_4 */ 28:
                    message.giftCardNumberLast4 = reader.string();
                    break;
                case /* bool is_interac */ 29:
                    message.isInterac = reader.bool();
                    break;
                case /* map<string, rd.proto.money.Money> surcharge_tax_by_tax_rate_id */ 30:
                    this.binaryReadMap30(message.surchargeTaxByTaxRateId, reader, options);
                    break;
                case /* rd.proto.money.Money cash_rounding_delta */ 31:
                    message.cashRoundingDelta = Money.internalBinaryRead(reader, reader.uint32(), options, message.cashRoundingDelta);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: LedgerEntry_Payment["purchaseAllocationsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_Payment["purchaseAllocationsById"] | undefined, val: LedgerEntry_Payment["purchaseAllocationsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.Payment.purchase_allocations_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap14(map: LedgerEntry_Payment["financeChargeAllocationsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_Payment["financeChargeAllocationsById"] | undefined, val: LedgerEntry_Payment["financeChargeAllocationsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.Payment.finance_charge_allocations_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap15(map: LedgerEntry_Payment["depositPurchaseAllocationsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_Payment["depositPurchaseAllocationsById"] | undefined, val: LedgerEntry_Payment["depositPurchaseAllocationsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.Payment.deposit_purchase_allocations_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap17(map: LedgerEntry_Payment["paymentCreditAllocationsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_Payment["paymentCreditAllocationsById"] | undefined, val: LedgerEntry_Payment["paymentCreditAllocationsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.Payment.payment_credit_allocations_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap18(map: LedgerEntry_Payment["writeOffCreditAllocationsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_Payment["writeOffCreditAllocationsById"] | undefined, val: LedgerEntry_Payment["writeOffCreditAllocationsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.Payment.write_off_credit_allocations_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap19(map: LedgerEntry_Payment["returnCreditAllocationsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_Payment["returnCreditAllocationsById"] | undefined, val: LedgerEntry_Payment["returnCreditAllocationsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.Payment.return_credit_allocations_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap21(map: LedgerEntry_Payment["fallbackAllocationsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_Payment["fallbackAllocationsById"] | undefined, val: LedgerEntry_Payment["fallbackAllocationsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.Payment.fallback_allocations_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap30(map: LedgerEntry_Payment["surchargeTaxByTaxRateId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_Payment["surchargeTaxByTaxRateId"] | undefined, val: LedgerEntry_Payment["surchargeTaxByTaxRateId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.Payment.surcharge_tax_by_tax_rate_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: LedgerEntry_Payment, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, rd.proto.money.Money> purchase_allocations_by_id = 2; */
        for (let k of globalThis.Object.keys(message.purchaseAllocationsById)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.purchaseAllocationsById[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money cash_received = 4; */
        if (message.cashReceived)
            Money.internalBinaryWrite(message.cashReceived, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string stripe_payment_intent_id = 5; */
        if (message.stripePaymentIntentId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.stripePaymentIntentId);
        /* string check_number = 6; */
        if (message.checkNumber !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.checkNumber);
        /* rd.proto.uuid.UUID bill_payment_id = 7; */
        if (message.billPaymentId)
            UUID.internalBinaryWrite(message.billPaymentId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money fee = 8; */
        if (message.fee)
            Money.internalBinaryWrite(message.fee, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.CashRegister cash_register = 9; */
        if (message.cashRegister)
            CashRegister.internalBinaryWrite(message.cashRegister, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.payments.Card card = 10; */
        if (message.card)
            Card.internalBinaryWrite(message.card, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money surcharge = 11; */
        if (message.surcharge)
            Money.internalBinaryWrite(message.surcharge, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money surcharge_tax = 12; */
        if (message.surchargeTax)
            Money.internalBinaryWrite(message.surchargeTax, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> finance_charge_allocations_by_id = 14; */
        for (let k of globalThis.Object.keys(message.financeChargeAllocationsById)) {
            writer.tag(14, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.financeChargeAllocationsById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> deposit_purchase_allocations_by_id = 15; */
        for (let k of globalThis.Object.keys(message.depositPurchaseAllocationsById)) {
            writer.tag(15, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.depositPurchaseAllocationsById[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money unallocated_credits_added = 16; */
        if (message.unallocatedCreditsAdded)
            Money.internalBinaryWrite(message.unallocatedCreditsAdded, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> payment_credit_allocations_by_id = 17; */
        for (let k of globalThis.Object.keys(message.paymentCreditAllocationsById)) {
            writer.tag(17, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.paymentCreditAllocationsById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> write_off_credit_allocations_by_id = 18; */
        for (let k of globalThis.Object.keys(message.writeOffCreditAllocationsById)) {
            writer.tag(18, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.writeOffCreditAllocationsById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> return_credit_allocations_by_id = 19; */
        for (let k of globalThis.Object.keys(message.returnCreditAllocationsById)) {
            writer.tag(19, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.returnCreditAllocationsById[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.uuid.UUID tender_method_id = 20; */
        if (message.tenderMethodId)
            UUID.internalBinaryWrite(message.tenderMethodId, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> fallback_allocations_by_id = 21; */
        for (let k of globalThis.Object.keys(message.fallbackAllocationsById)) {
            writer.tag(21, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.fallbackAllocationsById[k], writer, options);
            writer.join().join();
        }
        /* bool should_print_receipt = 22; */
        if (message.shouldPrintReceipt !== false)
            writer.tag(22, WireType.Varint).bool(message.shouldPrintReceipt);
        /* string custom_note = 23; */
        if (message.customNote !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.customNote);
        /* string stripe_charge_id = 24; */
        if (message.stripeChargeId !== "")
            writer.tag(24, WireType.LengthDelimited).string(message.stripeChargeId);
        /* rd.payments.BankPaymentMethod bank_payment_method = 25; */
        if (message.bankPaymentMethod)
            BankPaymentMethod.internalBinaryWrite(message.bankPaymentMethod, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID gift_card_activation_ledger_entry_id = 27; */
        if (message.giftCardActivationLedgerEntryId)
            UUID.internalBinaryWrite(message.giftCardActivationLedgerEntryId, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* string gift_card_number_last_4 = 28; */
        if (message.giftCardNumberLast4 !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.giftCardNumberLast4);
        /* bool is_interac = 29; */
        if (message.isInterac !== false)
            writer.tag(29, WireType.Varint).bool(message.isInterac);
        /* map<string, rd.proto.money.Money> surcharge_tax_by_tax_rate_id = 30; */
        for (let k of globalThis.Object.keys(message.surchargeTaxByTaxRateId)) {
            writer.tag(30, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.surchargeTaxByTaxRateId[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money cash_rounding_delta = 31; */
        if (message.cashRoundingDelta)
            Money.internalBinaryWrite(message.cashRoundingDelta, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.Payment
 */
export const LedgerEntry_Payment = new LedgerEntry_Payment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_Refund$Type extends MessageType<LedgerEntry_Refund> {
    constructor() {
        super("rd.ledger.LedgerEntry.Refund", [
            { no: 1, name: "payment_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 2, name: "return_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 3, name: "stripe_refund_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "cash_register", kind: "message", T: () => CashRegister },
            { no: 6, name: "surcharge", kind: "message", T: () => Money },
            { no: 7, name: "surcharge_tax", kind: "message", T: () => Money },
            { no: 8, name: "deposit_redemption_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 9, name: "unallocated_credits", kind: "message", T: () => Money },
            { no: 10, name: "purchase_unallocations_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 11, name: "finance_charge_unallocations_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 12, name: "is_unlinked_payment", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "card", kind: "message", T: () => Card },
            { no: 14, name: "payment_credit_unallocations_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 15, name: "write_off_credit_unallocations_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 16, name: "fee", kind: "message", T: () => Money },
            { no: 17, name: "return_credit_unallocations_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 18, name: "stripe_charge_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "tender_method_id", kind: "message", T: () => UUID },
            { no: 20, name: "check_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "custom_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "bank_payment_method", kind: "message", T: () => BankPaymentMethod },
            { no: 23, name: "fallback_unallocations_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 25, name: "gift_card_activation_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 26, name: "gift_card_number_last_4", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "deposit_purchase_unallocation_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 28, name: "surcharge_tax_by_tax_rate_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 29, name: "cash_rounding_delta", kind: "message", T: () => Money },
            { no: 30, name: "payment_cash_rounding_delta", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_Refund>): LedgerEntry_Refund {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripeRefundId = "";
        message.purchaseUnallocationsById = {};
        message.financeChargeUnallocationsById = {};
        message.isUnlinkedPayment = false;
        message.paymentCreditUnallocationsById = {};
        message.writeOffCreditUnallocationsById = {};
        message.returnCreditUnallocationsById = {};
        message.stripeChargeId = "";
        message.checkNumber = "";
        message.customNote = "";
        message.fallbackUnallocationsById = {};
        message.giftCardNumberLast4 = "";
        message.surchargeTaxByTaxRateId = {};
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_Refund>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_Refund): LedgerEntry_Refund {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID payment_ledger_entry_id */ 1:
                    message.paymentLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.paymentLedgerEntryId);
                    break;
                case /* rd.proto.uuid.UUID return_ledger_entry_id */ 2:
                    message.returnLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.returnLedgerEntryId);
                    break;
                case /* string stripe_refund_id */ 3:
                    message.stripeRefundId = reader.string();
                    break;
                case /* rd.company.CashRegister cash_register */ 5:
                    message.cashRegister = CashRegister.internalBinaryRead(reader, reader.uint32(), options, message.cashRegister);
                    break;
                case /* rd.proto.money.Money surcharge */ 6:
                    message.surcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.surcharge);
                    break;
                case /* rd.proto.money.Money surcharge_tax */ 7:
                    message.surchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.surchargeTax);
                    break;
                case /* rd.proto.uuid.UUID deposit_redemption_ledger_entry_id */ 8:
                    message.depositRedemptionLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.depositRedemptionLedgerEntryId);
                    break;
                case /* rd.proto.money.Money unallocated_credits */ 9:
                    message.unallocatedCredits = Money.internalBinaryRead(reader, reader.uint32(), options, message.unallocatedCredits);
                    break;
                case /* map<string, rd.proto.money.Money> purchase_unallocations_by_id */ 10:
                    this.binaryReadMap10(message.purchaseUnallocationsById, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> finance_charge_unallocations_by_id */ 11:
                    this.binaryReadMap11(message.financeChargeUnallocationsById, reader, options);
                    break;
                case /* bool is_unlinked_payment */ 12:
                    message.isUnlinkedPayment = reader.bool();
                    break;
                case /* rd.payments.Card card */ 13:
                    message.card = Card.internalBinaryRead(reader, reader.uint32(), options, message.card);
                    break;
                case /* map<string, rd.proto.money.Money> payment_credit_unallocations_by_id */ 14:
                    this.binaryReadMap14(message.paymentCreditUnallocationsById, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> write_off_credit_unallocations_by_id */ 15:
                    this.binaryReadMap15(message.writeOffCreditUnallocationsById, reader, options);
                    break;
                case /* rd.proto.money.Money fee */ 16:
                    message.fee = Money.internalBinaryRead(reader, reader.uint32(), options, message.fee);
                    break;
                case /* map<string, rd.proto.money.Money> return_credit_unallocations_by_id */ 17:
                    this.binaryReadMap17(message.returnCreditUnallocationsById, reader, options);
                    break;
                case /* string stripe_charge_id */ 18:
                    message.stripeChargeId = reader.string();
                    break;
                case /* rd.proto.uuid.UUID tender_method_id */ 19:
                    message.tenderMethodId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.tenderMethodId);
                    break;
                case /* string check_number */ 20:
                    message.checkNumber = reader.string();
                    break;
                case /* string custom_note */ 21:
                    message.customNote = reader.string();
                    break;
                case /* rd.payments.BankPaymentMethod bank_payment_method */ 22:
                    message.bankPaymentMethod = BankPaymentMethod.internalBinaryRead(reader, reader.uint32(), options, message.bankPaymentMethod);
                    break;
                case /* map<string, rd.proto.money.Money> fallback_unallocations_by_id */ 23:
                    this.binaryReadMap23(message.fallbackUnallocationsById, reader, options);
                    break;
                case /* rd.proto.uuid.UUID gift_card_activation_ledger_entry_id */ 25:
                    message.giftCardActivationLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.giftCardActivationLedgerEntryId);
                    break;
                case /* string gift_card_number_last_4 */ 26:
                    message.giftCardNumberLast4 = reader.string();
                    break;
                case /* rd.proto.uuid.UUID deposit_purchase_unallocation_ledger_entry_id */ 27:
                    message.depositPurchaseUnallocationLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.depositPurchaseUnallocationLedgerEntryId);
                    break;
                case /* map<string, rd.proto.money.Money> surcharge_tax_by_tax_rate_id */ 28:
                    this.binaryReadMap28(message.surchargeTaxByTaxRateId, reader, options);
                    break;
                case /* rd.proto.money.Money cash_rounding_delta */ 29:
                    message.cashRoundingDelta = Money.internalBinaryRead(reader, reader.uint32(), options, message.cashRoundingDelta);
                    break;
                case /* rd.proto.money.Money payment_cash_rounding_delta */ 30:
                    message.paymentCashRoundingDelta = Money.internalBinaryRead(reader, reader.uint32(), options, message.paymentCashRoundingDelta);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap10(map: LedgerEntry_Refund["purchaseUnallocationsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_Refund["purchaseUnallocationsById"] | undefined, val: LedgerEntry_Refund["purchaseUnallocationsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.Refund.purchase_unallocations_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap11(map: LedgerEntry_Refund["financeChargeUnallocationsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_Refund["financeChargeUnallocationsById"] | undefined, val: LedgerEntry_Refund["financeChargeUnallocationsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.Refund.finance_charge_unallocations_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap14(map: LedgerEntry_Refund["paymentCreditUnallocationsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_Refund["paymentCreditUnallocationsById"] | undefined, val: LedgerEntry_Refund["paymentCreditUnallocationsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.Refund.payment_credit_unallocations_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap15(map: LedgerEntry_Refund["writeOffCreditUnallocationsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_Refund["writeOffCreditUnallocationsById"] | undefined, val: LedgerEntry_Refund["writeOffCreditUnallocationsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.Refund.write_off_credit_unallocations_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap17(map: LedgerEntry_Refund["returnCreditUnallocationsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_Refund["returnCreditUnallocationsById"] | undefined, val: LedgerEntry_Refund["returnCreditUnallocationsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.Refund.return_credit_unallocations_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap23(map: LedgerEntry_Refund["fallbackUnallocationsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_Refund["fallbackUnallocationsById"] | undefined, val: LedgerEntry_Refund["fallbackUnallocationsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.Refund.fallback_unallocations_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap28(map: LedgerEntry_Refund["surchargeTaxByTaxRateId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_Refund["surchargeTaxByTaxRateId"] | undefined, val: LedgerEntry_Refund["surchargeTaxByTaxRateId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.Refund.surcharge_tax_by_tax_rate_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: LedgerEntry_Refund, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID payment_ledger_entry_id = 1; */
        if (message.paymentLedgerEntryId)
            UUID.internalBinaryWrite(message.paymentLedgerEntryId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID return_ledger_entry_id = 2; */
        if (message.returnLedgerEntryId)
            UUID.internalBinaryWrite(message.returnLedgerEntryId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string stripe_refund_id = 3; */
        if (message.stripeRefundId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.stripeRefundId);
        /* rd.company.CashRegister cash_register = 5; */
        if (message.cashRegister)
            CashRegister.internalBinaryWrite(message.cashRegister, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money surcharge = 6; */
        if (message.surcharge)
            Money.internalBinaryWrite(message.surcharge, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money surcharge_tax = 7; */
        if (message.surchargeTax)
            Money.internalBinaryWrite(message.surchargeTax, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID deposit_redemption_ledger_entry_id = 8; */
        if (message.depositRedemptionLedgerEntryId)
            UUID.internalBinaryWrite(message.depositRedemptionLedgerEntryId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money unallocated_credits = 9; */
        if (message.unallocatedCredits)
            Money.internalBinaryWrite(message.unallocatedCredits, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> purchase_unallocations_by_id = 10; */
        for (let k of globalThis.Object.keys(message.purchaseUnallocationsById)) {
            writer.tag(10, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.purchaseUnallocationsById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> finance_charge_unallocations_by_id = 11; */
        for (let k of globalThis.Object.keys(message.financeChargeUnallocationsById)) {
            writer.tag(11, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.financeChargeUnallocationsById[k], writer, options);
            writer.join().join();
        }
        /* bool is_unlinked_payment = 12; */
        if (message.isUnlinkedPayment !== false)
            writer.tag(12, WireType.Varint).bool(message.isUnlinkedPayment);
        /* rd.payments.Card card = 13; */
        if (message.card)
            Card.internalBinaryWrite(message.card, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> payment_credit_unallocations_by_id = 14; */
        for (let k of globalThis.Object.keys(message.paymentCreditUnallocationsById)) {
            writer.tag(14, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.paymentCreditUnallocationsById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> write_off_credit_unallocations_by_id = 15; */
        for (let k of globalThis.Object.keys(message.writeOffCreditUnallocationsById)) {
            writer.tag(15, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.writeOffCreditUnallocationsById[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money fee = 16; */
        if (message.fee)
            Money.internalBinaryWrite(message.fee, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> return_credit_unallocations_by_id = 17; */
        for (let k of globalThis.Object.keys(message.returnCreditUnallocationsById)) {
            writer.tag(17, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.returnCreditUnallocationsById[k], writer, options);
            writer.join().join();
        }
        /* string stripe_charge_id = 18; */
        if (message.stripeChargeId !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.stripeChargeId);
        /* rd.proto.uuid.UUID tender_method_id = 19; */
        if (message.tenderMethodId)
            UUID.internalBinaryWrite(message.tenderMethodId, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* string check_number = 20; */
        if (message.checkNumber !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.checkNumber);
        /* string custom_note = 21; */
        if (message.customNote !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.customNote);
        /* rd.payments.BankPaymentMethod bank_payment_method = 22; */
        if (message.bankPaymentMethod)
            BankPaymentMethod.internalBinaryWrite(message.bankPaymentMethod, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> fallback_unallocations_by_id = 23; */
        for (let k of globalThis.Object.keys(message.fallbackUnallocationsById)) {
            writer.tag(23, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.fallbackUnallocationsById[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.uuid.UUID gift_card_activation_ledger_entry_id = 25; */
        if (message.giftCardActivationLedgerEntryId)
            UUID.internalBinaryWrite(message.giftCardActivationLedgerEntryId, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* string gift_card_number_last_4 = 26; */
        if (message.giftCardNumberLast4 !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.giftCardNumberLast4);
        /* rd.proto.uuid.UUID deposit_purchase_unallocation_ledger_entry_id = 27; */
        if (message.depositPurchaseUnallocationLedgerEntryId)
            UUID.internalBinaryWrite(message.depositPurchaseUnallocationLedgerEntryId, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> surcharge_tax_by_tax_rate_id = 28; */
        for (let k of globalThis.Object.keys(message.surchargeTaxByTaxRateId)) {
            writer.tag(28, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.surchargeTaxByTaxRateId[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money cash_rounding_delta = 29; */
        if (message.cashRoundingDelta)
            Money.internalBinaryWrite(message.cashRoundingDelta, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money payment_cash_rounding_delta = 30; */
        if (message.paymentCashRoundingDelta)
            Money.internalBinaryWrite(message.paymentCashRoundingDelta, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.Refund
 */
export const LedgerEntry_Refund = new LedgerEntry_Refund$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_PettyCash$Type extends MessageType<LedgerEntry_PettyCash> {
    constructor() {
        super("rd.ledger.LedgerEntry.PettyCash", [
            { no: 1, name: "petty_cash_id", kind: "message", T: () => UUID },
            { no: 2, name: "cash_register", kind: "message", T: () => CashRegister }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_PettyCash>): LedgerEntry_PettyCash {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_PettyCash>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_PettyCash): LedgerEntry_PettyCash {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID petty_cash_id */ 1:
                    message.pettyCashId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.pettyCashId);
                    break;
                case /* rd.company.CashRegister cash_register */ 2:
                    message.cashRegister = CashRegister.internalBinaryRead(reader, reader.uint32(), options, message.cashRegister);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_PettyCash, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID petty_cash_id = 1; */
        if (message.pettyCashId)
            UUID.internalBinaryWrite(message.pettyCashId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.CashRegister cash_register = 2; */
        if (message.cashRegister)
            CashRegister.internalBinaryWrite(message.cashRegister, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.PettyCash
 */
export const LedgerEntry_PettyCash = new LedgerEntry_PettyCash$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_CloseOut$Type extends MessageType<LedgerEntry_CloseOut> {
    constructor() {
        super("rd.ledger.LedgerEntry.CloseOut", [
            { no: 1, name: "close_out_id", kind: "message", T: () => UUID },
            { no: 2, name: "cash_register", kind: "message", T: () => CashRegister }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_CloseOut>): LedgerEntry_CloseOut {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_CloseOut>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_CloseOut): LedgerEntry_CloseOut {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID close_out_id */ 1:
                    message.closeOutId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.closeOutId);
                    break;
                case /* rd.company.CashRegister cash_register */ 2:
                    message.cashRegister = CashRegister.internalBinaryRead(reader, reader.uint32(), options, message.cashRegister);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_CloseOut, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID close_out_id = 1; */
        if (message.closeOutId)
            UUID.internalBinaryWrite(message.closeOutId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.CashRegister cash_register = 2; */
        if (message.cashRegister)
            CashRegister.internalBinaryWrite(message.cashRegister, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.CloseOut
 */
export const LedgerEntry_CloseOut = new LedgerEntry_CloseOut$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_Allocation$Type extends MessageType<LedgerEntry_Allocation> {
    constructor() {
        super("rd.ledger.LedgerEntry.Allocation", [
            { no: 1, name: "allocation_amount", kind: "message", T: () => Money },
            { no: 2, name: "payment_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 3, name: "purchase_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 4, name: "write_off_ledger_entry_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_Allocation>): LedgerEntry_Allocation {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_Allocation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_Allocation): LedgerEntry_Allocation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money allocation_amount */ 1:
                    message.allocationAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.allocationAmount);
                    break;
                case /* rd.proto.uuid.UUID payment_ledger_entry_id */ 2:
                    message.paymentLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.paymentLedgerEntryId);
                    break;
                case /* rd.proto.uuid.UUID purchase_ledger_entry_id */ 3:
                    message.purchaseLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.purchaseLedgerEntryId);
                    break;
                case /* rd.proto.uuid.UUID write_off_ledger_entry_id */ 4:
                    message.writeOffLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.writeOffLedgerEntryId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_Allocation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money allocation_amount = 1; */
        if (message.allocationAmount)
            Money.internalBinaryWrite(message.allocationAmount, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID payment_ledger_entry_id = 2; */
        if (message.paymentLedgerEntryId)
            UUID.internalBinaryWrite(message.paymentLedgerEntryId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID purchase_ledger_entry_id = 3; */
        if (message.purchaseLedgerEntryId)
            UUID.internalBinaryWrite(message.purchaseLedgerEntryId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID write_off_ledger_entry_id = 4; */
        if (message.writeOffLedgerEntryId)
            UUID.internalBinaryWrite(message.writeOffLedgerEntryId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.Allocation
 */
export const LedgerEntry_Allocation = new LedgerEntry_Allocation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_Discount$Type extends MessageType<LedgerEntry_Discount> {
    constructor() {
        super("rd.ledger.LedgerEntry.Discount", [
            { no: 1, name: "purchase_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 3, name: "purchase_location_id", kind: "message", T: () => UUID },
            { no: 4, name: "bill_payment_id", kind: "message", T: () => UUID },
            { no: 5, name: "returned_from_sale_id", kind: "message", T: () => UUID },
            { no: 7, name: "sale_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_Discount>): LedgerEntry_Discount {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_Discount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_Discount): LedgerEntry_Discount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID purchase_ledger_entry_id */ 1:
                    message.purchaseLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.purchaseLedgerEntryId);
                    break;
                case /* rd.proto.uuid.UUID purchase_location_id */ 3:
                    message.purchaseLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.purchaseLocationId);
                    break;
                case /* rd.proto.uuid.UUID bill_payment_id */ 4:
                    message.billPaymentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.billPaymentId);
                    break;
                case /* rd.proto.uuid.UUID returned_from_sale_id */ 5:
                    message.returnedFromSaleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.returnedFromSaleId);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 7:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_Discount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID purchase_ledger_entry_id = 1; */
        if (message.purchaseLedgerEntryId)
            UUID.internalBinaryWrite(message.purchaseLedgerEntryId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID purchase_location_id = 3; */
        if (message.purchaseLocationId)
            UUID.internalBinaryWrite(message.purchaseLocationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID bill_payment_id = 4; */
        if (message.billPaymentId)
            UUID.internalBinaryWrite(message.billPaymentId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID returned_from_sale_id = 5; */
        if (message.returnedFromSaleId)
            UUID.internalBinaryWrite(message.returnedFromSaleId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 7; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.Discount
 */
export const LedgerEntry_Discount = new LedgerEntry_Discount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_ReverseDiscount$Type extends MessageType<LedgerEntry_ReverseDiscount> {
    constructor() {
        super("rd.ledger.LedgerEntry.ReverseDiscount", [
            { no: 1, name: "purchase_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 3, name: "discount_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 5, name: "purchase_location_id", kind: "message", T: () => UUID },
            { no: 6, name: "bill_payment_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_ReverseDiscount>): LedgerEntry_ReverseDiscount {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_ReverseDiscount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_ReverseDiscount): LedgerEntry_ReverseDiscount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID purchase_ledger_entry_id */ 1:
                    message.purchaseLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.purchaseLedgerEntryId);
                    break;
                case /* rd.proto.uuid.UUID discount_ledger_entry_id */ 3:
                    message.discountLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.discountLedgerEntryId);
                    break;
                case /* rd.proto.uuid.UUID purchase_location_id */ 5:
                    message.purchaseLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.purchaseLocationId);
                    break;
                case /* rd.proto.uuid.UUID bill_payment_id */ 6:
                    message.billPaymentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.billPaymentId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_ReverseDiscount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID purchase_ledger_entry_id = 1; */
        if (message.purchaseLedgerEntryId)
            UUID.internalBinaryWrite(message.purchaseLedgerEntryId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID discount_ledger_entry_id = 3; */
        if (message.discountLedgerEntryId)
            UUID.internalBinaryWrite(message.discountLedgerEntryId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID purchase_location_id = 5; */
        if (message.purchaseLocationId)
            UUID.internalBinaryWrite(message.purchaseLocationId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID bill_payment_id = 6; */
        if (message.billPaymentId)
            UUID.internalBinaryWrite(message.billPaymentId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.ReverseDiscount
 */
export const LedgerEntry_ReverseDiscount = new LedgerEntry_ReverseDiscount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_UomSnapshot$Type extends MessageType<LedgerEntry_UomSnapshot> {
    constructor() {
        super("rd.ledger.LedgerEntry.UomSnapshot", [
            { no: 1, name: "uom_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "uom_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "conversion_factor_to_base", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_UomSnapshot>): LedgerEntry_UomSnapshot {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uomCode = "";
        message.uomName = "";
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_UomSnapshot>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_UomSnapshot): LedgerEntry_UomSnapshot {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string uom_code */ 1:
                    message.uomCode = reader.string();
                    break;
                case /* string uom_name */ 2:
                    message.uomName = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal conversion_factor_to_base */ 3:
                    message.conversionFactorToBase = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.conversionFactorToBase);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_UomSnapshot, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string uom_code = 1; */
        if (message.uomCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.uomCode);
        /* string uom_name = 2; */
        if (message.uomName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.uomName);
        /* rd.proto.decimal.Decimal conversion_factor_to_base = 3; */
        if (message.conversionFactorToBase)
            Decimal.internalBinaryWrite(message.conversionFactorToBase, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.UomSnapshot
 */
export const LedgerEntry_UomSnapshot = new LedgerEntry_UomSnapshot$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_InventoryHold$Type extends MessageType<LedgerEntry_InventoryHold> {
    constructor() {
        super("rd.ledger.LedgerEntry.InventoryHold", [
            { no: 1, name: "subtype", kind: "enum", T: () => ["rd.ledger.LedgerEntry.InventoryHold.Subtype", LedgerEntry_InventoryHold_Subtype, "SUBTYPE_"] },
            { no: 3, name: "cost", kind: "message", T: () => FractionalMoney },
            { no: 4, name: "sale_id", kind: "message", T: () => UUID },
            { no: 5, name: "sale_product_id", kind: "message", T: () => UUID },
            { no: 6, name: "transfer_id", kind: "message", T: () => UUID },
            { no: 7, name: "order_id", kind: "message", T: () => UUID },
            { no: 8, name: "reversed_id", kind: "message", T: () => UUID },
            { no: 9, name: "order_product_id", kind: "message", T: () => UUID },
            { no: 10, name: "is_special_order", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "quantity_committed_v2", kind: "message", T: () => Decimal },
            { no: 12, name: "uom_id", kind: "message", T: () => UUID },
            { no: 13, name: "quantity_committed_uom", kind: "message", T: () => Decimal },
            { no: 14, name: "uom_snapshot", kind: "message", T: () => LedgerEntry_UomSnapshot },
            { no: 15, name: "is_non_stock", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_InventoryHold>): LedgerEntry_InventoryHold {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subtype = 0;
        message.isSpecialOrder = false;
        message.isNonStock = false;
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_InventoryHold>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_InventoryHold): LedgerEntry_InventoryHold {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.ledger.LedgerEntry.InventoryHold.Subtype subtype */ 1:
                    message.subtype = reader.int32();
                    break;
                case /* rd.proto.money.FractionalMoney cost */ 3:
                    message.cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.cost);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 4:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID sale_product_id */ 5:
                    message.saleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleProductId);
                    break;
                case /* rd.proto.uuid.UUID transfer_id */ 6:
                    message.transferId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.transferId);
                    break;
                case /* rd.proto.uuid.UUID order_id */ 7:
                    message.orderId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderId);
                    break;
                case /* rd.proto.uuid.UUID reversed_id */ 8:
                    message.reversedId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.reversedId);
                    break;
                case /* rd.proto.uuid.UUID order_product_id */ 9:
                    message.orderProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderProductId);
                    break;
                case /* bool is_special_order */ 10:
                    message.isSpecialOrder = reader.bool();
                    break;
                case /* rd.proto.decimal.Decimal quantity_committed_v2 */ 11:
                    message.quantityCommittedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityCommittedV2);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 12:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_committed_uom */ 13:
                    message.quantityCommittedUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityCommittedUom);
                    break;
                case /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot */ 14:
                    message.uomSnapshot = LedgerEntry_UomSnapshot.internalBinaryRead(reader, reader.uint32(), options, message.uomSnapshot);
                    break;
                case /* bool is_non_stock */ 15:
                    message.isNonStock = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_InventoryHold, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.ledger.LedgerEntry.InventoryHold.Subtype subtype = 1; */
        if (message.subtype !== 0)
            writer.tag(1, WireType.Varint).int32(message.subtype);
        /* rd.proto.money.FractionalMoney cost = 3; */
        if (message.cost)
            FractionalMoney.internalBinaryWrite(message.cost, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 4; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_product_id = 5; */
        if (message.saleProductId)
            UUID.internalBinaryWrite(message.saleProductId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID transfer_id = 6; */
        if (message.transferId)
            UUID.internalBinaryWrite(message.transferId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_id = 7; */
        if (message.orderId)
            UUID.internalBinaryWrite(message.orderId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID reversed_id = 8; */
        if (message.reversedId)
            UUID.internalBinaryWrite(message.reversedId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_product_id = 9; */
        if (message.orderProductId)
            UUID.internalBinaryWrite(message.orderProductId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* bool is_special_order = 10; */
        if (message.isSpecialOrder !== false)
            writer.tag(10, WireType.Varint).bool(message.isSpecialOrder);
        /* rd.proto.decimal.Decimal quantity_committed_v2 = 11; */
        if (message.quantityCommittedV2)
            Decimal.internalBinaryWrite(message.quantityCommittedV2, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 12; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_committed_uom = 13; */
        if (message.quantityCommittedUom)
            Decimal.internalBinaryWrite(message.quantityCommittedUom, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 14; */
        if (message.uomSnapshot)
            LedgerEntry_UomSnapshot.internalBinaryWrite(message.uomSnapshot, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* bool is_non_stock = 15; */
        if (message.isNonStock !== false)
            writer.tag(15, WireType.Varint).bool(message.isNonStock);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.InventoryHold
 */
export const LedgerEntry_InventoryHold = new LedgerEntry_InventoryHold$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_InventoryOrder$Type extends MessageType<LedgerEntry_InventoryOrder> {
    constructor() {
        super("rd.ledger.LedgerEntry.InventoryOrder", [
            { no: 1, name: "subtype", kind: "enum", T: () => ["rd.ledger.LedgerEntry.InventoryOrder.Subtype", LedgerEntry_InventoryOrder_Subtype, "SUBTYPE_"] },
            { no: 3, name: "cost", kind: "message", T: () => FractionalMoney },
            { no: 6, name: "transfer_id", kind: "message", T: () => UUID },
            { no: 7, name: "order_id", kind: "message", T: () => UUID },
            { no: 8, name: "reversed_id", kind: "message", T: () => UUID },
            { no: 9, name: "order_product_id", kind: "message", T: () => UUID },
            { no: 10, name: "is_special_order", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "sale_id", kind: "message", T: () => UUID },
            { no: 12, name: "sale_product_id", kind: "message", T: () => UUID },
            { no: 13, name: "quantity_ordered_v2", kind: "message", T: () => Decimal },
            { no: 14, name: "uom_id", kind: "message", T: () => UUID },
            { no: 15, name: "quantity_uom", kind: "message", T: () => Decimal },
            { no: 16, name: "old_quantity_uom", kind: "message", T: () => Decimal },
            { no: 17, name: "new_quantity_uom", kind: "message", T: () => Decimal },
            { no: 18, name: "uom_snapshot", kind: "message", T: () => LedgerEntry_UomSnapshot },
            { no: 19, name: "is_non_stock", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_InventoryOrder>): LedgerEntry_InventoryOrder {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subtype = 0;
        message.isSpecialOrder = false;
        message.isNonStock = false;
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_InventoryOrder>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_InventoryOrder): LedgerEntry_InventoryOrder {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.ledger.LedgerEntry.InventoryOrder.Subtype subtype */ 1:
                    message.subtype = reader.int32();
                    break;
                case /* rd.proto.money.FractionalMoney cost */ 3:
                    message.cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.cost);
                    break;
                case /* rd.proto.uuid.UUID transfer_id */ 6:
                    message.transferId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.transferId);
                    break;
                case /* rd.proto.uuid.UUID order_id */ 7:
                    message.orderId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderId);
                    break;
                case /* rd.proto.uuid.UUID reversed_id */ 8:
                    message.reversedId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.reversedId);
                    break;
                case /* rd.proto.uuid.UUID order_product_id */ 9:
                    message.orderProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderProductId);
                    break;
                case /* bool is_special_order */ 10:
                    message.isSpecialOrder = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 11:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID sale_product_id */ 12:
                    message.saleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleProductId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_ordered_v2 */ 13:
                    message.quantityOrderedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityOrderedV2);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 14:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_uom */ 15:
                    message.quantityUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityUom);
                    break;
                case /* rd.proto.decimal.Decimal old_quantity_uom */ 16:
                    message.oldQuantityUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.oldQuantityUom);
                    break;
                case /* rd.proto.decimal.Decimal new_quantity_uom */ 17:
                    message.newQuantityUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.newQuantityUom);
                    break;
                case /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot */ 18:
                    message.uomSnapshot = LedgerEntry_UomSnapshot.internalBinaryRead(reader, reader.uint32(), options, message.uomSnapshot);
                    break;
                case /* bool is_non_stock */ 19:
                    message.isNonStock = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_InventoryOrder, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.ledger.LedgerEntry.InventoryOrder.Subtype subtype = 1; */
        if (message.subtype !== 0)
            writer.tag(1, WireType.Varint).int32(message.subtype);
        /* rd.proto.money.FractionalMoney cost = 3; */
        if (message.cost)
            FractionalMoney.internalBinaryWrite(message.cost, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID transfer_id = 6; */
        if (message.transferId)
            UUID.internalBinaryWrite(message.transferId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_id = 7; */
        if (message.orderId)
            UUID.internalBinaryWrite(message.orderId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID reversed_id = 8; */
        if (message.reversedId)
            UUID.internalBinaryWrite(message.reversedId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_product_id = 9; */
        if (message.orderProductId)
            UUID.internalBinaryWrite(message.orderProductId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* bool is_special_order = 10; */
        if (message.isSpecialOrder !== false)
            writer.tag(10, WireType.Varint).bool(message.isSpecialOrder);
        /* rd.proto.uuid.UUID sale_id = 11; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_product_id = 12; */
        if (message.saleProductId)
            UUID.internalBinaryWrite(message.saleProductId, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_ordered_v2 = 13; */
        if (message.quantityOrderedV2)
            Decimal.internalBinaryWrite(message.quantityOrderedV2, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 14; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_uom = 15; */
        if (message.quantityUom)
            Decimal.internalBinaryWrite(message.quantityUom, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal old_quantity_uom = 16; */
        if (message.oldQuantityUom)
            Decimal.internalBinaryWrite(message.oldQuantityUom, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal new_quantity_uom = 17; */
        if (message.newQuantityUom)
            Decimal.internalBinaryWrite(message.newQuantityUom, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 18; */
        if (message.uomSnapshot)
            LedgerEntry_UomSnapshot.internalBinaryWrite(message.uomSnapshot, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* bool is_non_stock = 19; */
        if (message.isNonStock !== false)
            writer.tag(19, WireType.Varint).bool(message.isNonStock);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.InventoryOrder
 */
export const LedgerEntry_InventoryOrder = new LedgerEntry_InventoryOrder$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_InventoryReceipt$Type extends MessageType<LedgerEntry_InventoryReceipt> {
    constructor() {
        super("rd.ledger.LedgerEntry.InventoryReceipt", [
            { no: 1, name: "subtype", kind: "enum", T: () => ["rd.ledger.LedgerEntry.InventoryReceipt.Subtype", LedgerEntry_InventoryReceipt_Subtype, "SUBTYPE_"] },
            { no: 3, name: "cost", kind: "message", T: () => FractionalMoney },
            { no: 4, name: "returned_from_sale_id", kind: "message", T: () => UUID },
            { no: 5, name: "returned_from_sale_product_id", kind: "message", T: () => UUID },
            { no: 7, name: "transfer_id", kind: "message", T: () => UUID },
            { no: 8, name: "order_shipment_id", kind: "message", T: () => UUID },
            { no: 9, name: "order_product_id", kind: "message", T: () => UUID },
            { no: 10, name: "sale_id", kind: "message", T: () => UUID },
            { no: 11, name: "sale_product_id", kind: "message", T: () => UUID },
            { no: 12, name: "is_special_order", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "quantity_received_v2", kind: "message", T: () => Decimal },
            { no: 17, name: "is_non_stock", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_InventoryReceipt>): LedgerEntry_InventoryReceipt {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subtype = 0;
        message.isSpecialOrder = false;
        message.isNonStock = false;
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_InventoryReceipt>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_InventoryReceipt): LedgerEntry_InventoryReceipt {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.ledger.LedgerEntry.InventoryReceipt.Subtype subtype */ 1:
                    message.subtype = reader.int32();
                    break;
                case /* rd.proto.money.FractionalMoney cost */ 3:
                    message.cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.cost);
                    break;
                case /* rd.proto.uuid.UUID returned_from_sale_id */ 4:
                    message.returnedFromSaleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.returnedFromSaleId);
                    break;
                case /* rd.proto.uuid.UUID returned_from_sale_product_id */ 5:
                    message.returnedFromSaleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.returnedFromSaleProductId);
                    break;
                case /* rd.proto.uuid.UUID transfer_id */ 7:
                    message.transferId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.transferId);
                    break;
                case /* rd.proto.uuid.UUID order_shipment_id */ 8:
                    message.orderShipmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderShipmentId);
                    break;
                case /* rd.proto.uuid.UUID order_product_id */ 9:
                    message.orderProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderProductId);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 10:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID sale_product_id */ 11:
                    message.saleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleProductId);
                    break;
                case /* bool is_special_order */ 12:
                    message.isSpecialOrder = reader.bool();
                    break;
                case /* rd.proto.decimal.Decimal quantity_received_v2 */ 13:
                    message.quantityReceivedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReceivedV2);
                    break;
                case /* bool is_non_stock */ 17:
                    message.isNonStock = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_InventoryReceipt, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.ledger.LedgerEntry.InventoryReceipt.Subtype subtype = 1; */
        if (message.subtype !== 0)
            writer.tag(1, WireType.Varint).int32(message.subtype);
        /* rd.proto.money.FractionalMoney cost = 3; */
        if (message.cost)
            FractionalMoney.internalBinaryWrite(message.cost, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID returned_from_sale_id = 4; */
        if (message.returnedFromSaleId)
            UUID.internalBinaryWrite(message.returnedFromSaleId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID returned_from_sale_product_id = 5; */
        if (message.returnedFromSaleProductId)
            UUID.internalBinaryWrite(message.returnedFromSaleProductId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID transfer_id = 7; */
        if (message.transferId)
            UUID.internalBinaryWrite(message.transferId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_shipment_id = 8; */
        if (message.orderShipmentId)
            UUID.internalBinaryWrite(message.orderShipmentId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_product_id = 9; */
        if (message.orderProductId)
            UUID.internalBinaryWrite(message.orderProductId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 10; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_product_id = 11; */
        if (message.saleProductId)
            UUID.internalBinaryWrite(message.saleProductId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* bool is_special_order = 12; */
        if (message.isSpecialOrder !== false)
            writer.tag(12, WireType.Varint).bool(message.isSpecialOrder);
        /* rd.proto.decimal.Decimal quantity_received_v2 = 13; */
        if (message.quantityReceivedV2)
            Decimal.internalBinaryWrite(message.quantityReceivedV2, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* bool is_non_stock = 17; */
        if (message.isNonStock !== false)
            writer.tag(17, WireType.Varint).bool(message.isNonStock);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.InventoryReceipt
 */
export const LedgerEntry_InventoryReceipt = new LedgerEntry_InventoryReceipt$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_InventoryRelease$Type extends MessageType<LedgerEntry_InventoryRelease> {
    constructor() {
        super("rd.ledger.LedgerEntry.InventoryRelease", [
            { no: 1, name: "subtype", kind: "enum", T: () => ["rd.ledger.LedgerEntry.InventoryRelease.Subtype", LedgerEntry_InventoryRelease_Subtype, "SUBTYPE_"] },
            { no: 3, name: "cost", kind: "message", T: () => FractionalMoney },
            { no: 4, name: "sale_id", kind: "message", T: () => UUID },
            { no: 5, name: "sale_product_id", kind: "message", T: () => UUID },
            { no: 6, name: "transfer_id", kind: "message", T: () => UUID },
            { no: 7, name: "order_shipment_id", kind: "message", T: () => UUID },
            { no: 8, name: "order_product_id", kind: "message", T: () => UUID },
            { no: 9, name: "is_special_order", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "quantity_released_v2", kind: "message", T: () => Decimal },
            { no: 14, name: "is_non_stock", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_InventoryRelease>): LedgerEntry_InventoryRelease {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subtype = 0;
        message.isSpecialOrder = false;
        message.isNonStock = false;
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_InventoryRelease>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_InventoryRelease): LedgerEntry_InventoryRelease {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.ledger.LedgerEntry.InventoryRelease.Subtype subtype */ 1:
                    message.subtype = reader.int32();
                    break;
                case /* rd.proto.money.FractionalMoney cost */ 3:
                    message.cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.cost);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 4:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID sale_product_id */ 5:
                    message.saleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleProductId);
                    break;
                case /* rd.proto.uuid.UUID transfer_id */ 6:
                    message.transferId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.transferId);
                    break;
                case /* rd.proto.uuid.UUID order_shipment_id */ 7:
                    message.orderShipmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderShipmentId);
                    break;
                case /* rd.proto.uuid.UUID order_product_id */ 8:
                    message.orderProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderProductId);
                    break;
                case /* bool is_special_order */ 9:
                    message.isSpecialOrder = reader.bool();
                    break;
                case /* rd.proto.decimal.Decimal quantity_released_v2 */ 10:
                    message.quantityReleasedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReleasedV2);
                    break;
                case /* bool is_non_stock */ 14:
                    message.isNonStock = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_InventoryRelease, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.ledger.LedgerEntry.InventoryRelease.Subtype subtype = 1; */
        if (message.subtype !== 0)
            writer.tag(1, WireType.Varint).int32(message.subtype);
        /* rd.proto.money.FractionalMoney cost = 3; */
        if (message.cost)
            FractionalMoney.internalBinaryWrite(message.cost, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 4; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_product_id = 5; */
        if (message.saleProductId)
            UUID.internalBinaryWrite(message.saleProductId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID transfer_id = 6; */
        if (message.transferId)
            UUID.internalBinaryWrite(message.transferId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_shipment_id = 7; */
        if (message.orderShipmentId)
            UUID.internalBinaryWrite(message.orderShipmentId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_product_id = 8; */
        if (message.orderProductId)
            UUID.internalBinaryWrite(message.orderProductId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool is_special_order = 9; */
        if (message.isSpecialOrder !== false)
            writer.tag(9, WireType.Varint).bool(message.isSpecialOrder);
        /* rd.proto.decimal.Decimal quantity_released_v2 = 10; */
        if (message.quantityReleasedV2)
            Decimal.internalBinaryWrite(message.quantityReleasedV2, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* bool is_non_stock = 14; */
        if (message.isNonStock !== false)
            writer.tag(14, WireType.Varint).bool(message.isNonStock);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.InventoryRelease
 */
export const LedgerEntry_InventoryRelease = new LedgerEntry_InventoryRelease$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_InventoryCount$Type extends MessageType<LedgerEntry_InventoryCount> {
    constructor() {
        super("rd.ledger.LedgerEntry.InventoryCount", [
            { no: 1, name: "subtype", kind: "enum", T: () => ["rd.ledger.LedgerEntry.InventoryCount.Subtype", LedgerEntry_InventoryCount_Subtype, "SUBTYPE_"] },
            { no: 4, name: "cost", kind: "message", T: () => FractionalMoney },
            { no: 5, name: "inventory_count_id", kind: "message", T: () => UUID },
            { no: 6, name: "is_special_order", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "new_quantity_v2", kind: "message", T: () => Decimal },
            { no: 8, name: "old_quantity_v2", kind: "message", T: () => Decimal },
            { no: 9, name: "uom_id", kind: "message", T: () => UUID },
            { no: 10, name: "new_quantity_uom", kind: "message", T: () => Decimal },
            { no: 11, name: "old_quantity_uom", kind: "message", T: () => Decimal },
            { no: 12, name: "uom_snapshot", kind: "message", T: () => LedgerEntry_UomSnapshot },
            { no: 13, name: "is_non_stock", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_InventoryCount>): LedgerEntry_InventoryCount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subtype = 0;
        message.isSpecialOrder = false;
        message.isNonStock = false;
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_InventoryCount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_InventoryCount): LedgerEntry_InventoryCount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.ledger.LedgerEntry.InventoryCount.Subtype subtype */ 1:
                    message.subtype = reader.int32();
                    break;
                case /* rd.proto.money.FractionalMoney cost */ 4:
                    message.cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.cost);
                    break;
                case /* rd.proto.uuid.UUID inventory_count_id */ 5:
                    message.inventoryCountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.inventoryCountId);
                    break;
                case /* bool is_special_order */ 6:
                    message.isSpecialOrder = reader.bool();
                    break;
                case /* rd.proto.decimal.Decimal new_quantity_v2 */ 7:
                    message.newQuantityV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.newQuantityV2);
                    break;
                case /* rd.proto.decimal.Decimal old_quantity_v2 */ 8:
                    message.oldQuantityV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.oldQuantityV2);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 9:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal new_quantity_uom */ 10:
                    message.newQuantityUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.newQuantityUom);
                    break;
                case /* rd.proto.decimal.Decimal old_quantity_uom */ 11:
                    message.oldQuantityUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.oldQuantityUom);
                    break;
                case /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot */ 12:
                    message.uomSnapshot = LedgerEntry_UomSnapshot.internalBinaryRead(reader, reader.uint32(), options, message.uomSnapshot);
                    break;
                case /* bool is_non_stock */ 13:
                    message.isNonStock = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_InventoryCount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.ledger.LedgerEntry.InventoryCount.Subtype subtype = 1; */
        if (message.subtype !== 0)
            writer.tag(1, WireType.Varint).int32(message.subtype);
        /* rd.proto.money.FractionalMoney cost = 4; */
        if (message.cost)
            FractionalMoney.internalBinaryWrite(message.cost, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID inventory_count_id = 5; */
        if (message.inventoryCountId)
            UUID.internalBinaryWrite(message.inventoryCountId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bool is_special_order = 6; */
        if (message.isSpecialOrder !== false)
            writer.tag(6, WireType.Varint).bool(message.isSpecialOrder);
        /* rd.proto.decimal.Decimal new_quantity_v2 = 7; */
        if (message.newQuantityV2)
            Decimal.internalBinaryWrite(message.newQuantityV2, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal old_quantity_v2 = 8; */
        if (message.oldQuantityV2)
            Decimal.internalBinaryWrite(message.oldQuantityV2, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 9; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal new_quantity_uom = 10; */
        if (message.newQuantityUom)
            Decimal.internalBinaryWrite(message.newQuantityUom, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal old_quantity_uom = 11; */
        if (message.oldQuantityUom)
            Decimal.internalBinaryWrite(message.oldQuantityUom, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 12; */
        if (message.uomSnapshot)
            LedgerEntry_UomSnapshot.internalBinaryWrite(message.uomSnapshot, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* bool is_non_stock = 13; */
        if (message.isNonStock !== false)
            writer.tag(13, WireType.Varint).bool(message.isNonStock);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.InventoryCount
 */
export const LedgerEntry_InventoryCount = new LedgerEntry_InventoryCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_InventoryCostEdit$Type extends MessageType<LedgerEntry_InventoryCostEdit> {
    constructor() {
        super("rd.ledger.LedgerEntry.InventoryCostEdit", [
            { no: 1, name: "subtype", kind: "enum", T: () => ["rd.ledger.LedgerEntry.InventoryCostEdit.Subtype", LedgerEntry_InventoryCostEdit_Subtype, "SUBTYPE_"] },
            { no: 2, name: "new_cost", kind: "message", T: () => FractionalMoney },
            { no: 3, name: "old_cost", kind: "message", T: () => FractionalMoney },
            { no: 4, name: "sale_id", kind: "message", T: () => UUID },
            { no: 5, name: "sale_product_id", kind: "message", T: () => UUID },
            { no: 7, name: "order_shipment_id", kind: "message", T: () => UUID },
            { no: 9, name: "order_product_id", kind: "message", T: () => UUID },
            { no: 10, name: "returned_from_sale_product_id", kind: "message", T: () => UUID },
            { no: 11, name: "returned_from_sale_id", kind: "message", T: () => UUID },
            { no: 12, name: "is_special_order", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "quantity_v2", kind: "message", T: () => Decimal },
            { no: 14, name: "uom_id", kind: "message", T: () => UUID },
            { no: 15, name: "quantity_uom", kind: "message", T: () => Decimal },
            { no: 16, name: "uom_snapshot", kind: "message", T: () => LedgerEntry_UomSnapshot },
            { no: 17, name: "is_non_stock", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_InventoryCostEdit>): LedgerEntry_InventoryCostEdit {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subtype = 0;
        message.isSpecialOrder = false;
        message.isNonStock = false;
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_InventoryCostEdit>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_InventoryCostEdit): LedgerEntry_InventoryCostEdit {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.ledger.LedgerEntry.InventoryCostEdit.Subtype subtype */ 1:
                    message.subtype = reader.int32();
                    break;
                case /* rd.proto.money.FractionalMoney new_cost */ 2:
                    message.newCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.newCost);
                    break;
                case /* rd.proto.money.FractionalMoney old_cost */ 3:
                    message.oldCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.oldCost);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 4:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID sale_product_id */ 5:
                    message.saleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleProductId);
                    break;
                case /* rd.proto.uuid.UUID order_shipment_id */ 7:
                    message.orderShipmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderShipmentId);
                    break;
                case /* rd.proto.uuid.UUID order_product_id */ 9:
                    message.orderProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderProductId);
                    break;
                case /* rd.proto.uuid.UUID returned_from_sale_product_id */ 10:
                    message.returnedFromSaleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.returnedFromSaleProductId);
                    break;
                case /* rd.proto.uuid.UUID returned_from_sale_id */ 11:
                    message.returnedFromSaleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.returnedFromSaleId);
                    break;
                case /* bool is_special_order */ 12:
                    message.isSpecialOrder = reader.bool();
                    break;
                case /* rd.proto.decimal.Decimal quantity_v2 */ 13:
                    message.quantityV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityV2);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 14:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_uom */ 15:
                    message.quantityUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityUom);
                    break;
                case /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot */ 16:
                    message.uomSnapshot = LedgerEntry_UomSnapshot.internalBinaryRead(reader, reader.uint32(), options, message.uomSnapshot);
                    break;
                case /* bool is_non_stock */ 17:
                    message.isNonStock = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_InventoryCostEdit, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.ledger.LedgerEntry.InventoryCostEdit.Subtype subtype = 1; */
        if (message.subtype !== 0)
            writer.tag(1, WireType.Varint).int32(message.subtype);
        /* rd.proto.money.FractionalMoney new_cost = 2; */
        if (message.newCost)
            FractionalMoney.internalBinaryWrite(message.newCost, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney old_cost = 3; */
        if (message.oldCost)
            FractionalMoney.internalBinaryWrite(message.oldCost, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 4; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_product_id = 5; */
        if (message.saleProductId)
            UUID.internalBinaryWrite(message.saleProductId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_shipment_id = 7; */
        if (message.orderShipmentId)
            UUID.internalBinaryWrite(message.orderShipmentId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_product_id = 9; */
        if (message.orderProductId)
            UUID.internalBinaryWrite(message.orderProductId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID returned_from_sale_product_id = 10; */
        if (message.returnedFromSaleProductId)
            UUID.internalBinaryWrite(message.returnedFromSaleProductId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID returned_from_sale_id = 11; */
        if (message.returnedFromSaleId)
            UUID.internalBinaryWrite(message.returnedFromSaleId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* bool is_special_order = 12; */
        if (message.isSpecialOrder !== false)
            writer.tag(12, WireType.Varint).bool(message.isSpecialOrder);
        /* rd.proto.decimal.Decimal quantity_v2 = 13; */
        if (message.quantityV2)
            Decimal.internalBinaryWrite(message.quantityV2, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 14; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_uom = 15; */
        if (message.quantityUom)
            Decimal.internalBinaryWrite(message.quantityUom, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 16; */
        if (message.uomSnapshot)
            LedgerEntry_UomSnapshot.internalBinaryWrite(message.uomSnapshot, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* bool is_non_stock = 17; */
        if (message.isNonStock !== false)
            writer.tag(17, WireType.Varint).bool(message.isNonStock);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.InventoryCostEdit
 */
export const LedgerEntry_InventoryCostEdit = new LedgerEntry_InventoryCostEdit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_InventoryMetadata$Type extends MessageType<LedgerEntry_InventoryMetadata> {
    constructor() {
        super("rd.ledger.LedgerEntry.InventoryMetadata", [
            { no: 1, name: "average_cost", kind: "message", T: () => FractionalMoney },
            { no: 5, name: "on_hand_inventories_by_location_id_v2", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Decimal } },
            { no: 6, name: "on_order_inventories_by_location_id_v2", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Decimal } },
            { no: 7, name: "committed_inventories_by_location_id_v2", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Decimal } }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_InventoryMetadata>): LedgerEntry_InventoryMetadata {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.onHandInventoriesByLocationIdV2 = {};
        message.onOrderInventoriesByLocationIdV2 = {};
        message.committedInventoriesByLocationIdV2 = {};
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_InventoryMetadata>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_InventoryMetadata): LedgerEntry_InventoryMetadata {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.FractionalMoney average_cost */ 1:
                    message.averageCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.averageCost);
                    break;
                case /* map<string, rd.proto.decimal.Decimal> on_hand_inventories_by_location_id_v2 */ 5:
                    this.binaryReadMap5(message.onHandInventoriesByLocationIdV2, reader, options);
                    break;
                case /* map<string, rd.proto.decimal.Decimal> on_order_inventories_by_location_id_v2 */ 6:
                    this.binaryReadMap6(message.onOrderInventoriesByLocationIdV2, reader, options);
                    break;
                case /* map<string, rd.proto.decimal.Decimal> committed_inventories_by_location_id_v2 */ 7:
                    this.binaryReadMap7(message.committedInventoriesByLocationIdV2, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: LedgerEntry_InventoryMetadata["onHandInventoriesByLocationIdV2"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_InventoryMetadata["onHandInventoriesByLocationIdV2"] | undefined, val: LedgerEntry_InventoryMetadata["onHandInventoriesByLocationIdV2"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Decimal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.InventoryMetadata.on_hand_inventories_by_location_id_v2");
            }
        }
        map[key ?? ""] = val ?? Decimal.create();
    }
    private binaryReadMap6(map: LedgerEntry_InventoryMetadata["onOrderInventoriesByLocationIdV2"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_InventoryMetadata["onOrderInventoriesByLocationIdV2"] | undefined, val: LedgerEntry_InventoryMetadata["onOrderInventoriesByLocationIdV2"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Decimal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.InventoryMetadata.on_order_inventories_by_location_id_v2");
            }
        }
        map[key ?? ""] = val ?? Decimal.create();
    }
    private binaryReadMap7(map: LedgerEntry_InventoryMetadata["committedInventoriesByLocationIdV2"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_InventoryMetadata["committedInventoriesByLocationIdV2"] | undefined, val: LedgerEntry_InventoryMetadata["committedInventoriesByLocationIdV2"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Decimal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.InventoryMetadata.committed_inventories_by_location_id_v2");
            }
        }
        map[key ?? ""] = val ?? Decimal.create();
    }
    internalBinaryWrite(message: LedgerEntry_InventoryMetadata, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.FractionalMoney average_cost = 1; */
        if (message.averageCost)
            FractionalMoney.internalBinaryWrite(message.averageCost, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.decimal.Decimal> on_hand_inventories_by_location_id_v2 = 5; */
        for (let k of globalThis.Object.keys(message.onHandInventoriesByLocationIdV2)) {
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Decimal.internalBinaryWrite(message.onHandInventoriesByLocationIdV2[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.decimal.Decimal> on_order_inventories_by_location_id_v2 = 6; */
        for (let k of globalThis.Object.keys(message.onOrderInventoriesByLocationIdV2)) {
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Decimal.internalBinaryWrite(message.onOrderInventoriesByLocationIdV2[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.decimal.Decimal> committed_inventories_by_location_id_v2 = 7; */
        for (let k of globalThis.Object.keys(message.committedInventoriesByLocationIdV2)) {
            writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Decimal.internalBinaryWrite(message.committedInventoriesByLocationIdV2[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.InventoryMetadata
 */
export const LedgerEntry_InventoryMetadata = new LedgerEntry_InventoryMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_DepositPurchase$Type extends MessageType<LedgerEntry_DepositPurchase> {
    constructor() {
        super("rd.ledger.LedgerEntry.DepositPurchase", [
            { no: 1, name: "sale_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_DepositPurchase>): LedgerEntry_DepositPurchase {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_DepositPurchase>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_DepositPurchase): LedgerEntry_DepositPurchase {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID sale_id */ 1:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_DepositPurchase, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID sale_id = 1; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.DepositPurchase
 */
export const LedgerEntry_DepositPurchase = new LedgerEntry_DepositPurchase$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_DepositRedemption$Type extends MessageType<LedgerEntry_DepositRedemption> {
    constructor() {
        super("rd.ledger.LedgerEntry.DepositRedemption", [
            { no: 1, name: "deposit_purchase_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 2, name: "sale_id", kind: "message", T: () => UUID },
            { no: 3, name: "purchase_ledger_entry_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_DepositRedemption>): LedgerEntry_DepositRedemption {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_DepositRedemption>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_DepositRedemption): LedgerEntry_DepositRedemption {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID deposit_purchase_ledger_entry_id */ 1:
                    message.depositPurchaseLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.depositPurchaseLedgerEntryId);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 2:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID purchase_ledger_entry_id */ 3:
                    message.purchaseLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.purchaseLedgerEntryId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_DepositRedemption, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID deposit_purchase_ledger_entry_id = 1; */
        if (message.depositPurchaseLedgerEntryId)
            UUID.internalBinaryWrite(message.depositPurchaseLedgerEntryId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 2; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID purchase_ledger_entry_id = 3; */
        if (message.purchaseLedgerEntryId)
            UUID.internalBinaryWrite(message.purchaseLedgerEntryId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.DepositRedemption
 */
export const LedgerEntry_DepositRedemption = new LedgerEntry_DepositRedemption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_DepositForfeiture$Type extends MessageType<LedgerEntry_DepositForfeiture> {
    constructor() {
        super("rd.ledger.LedgerEntry.DepositForfeiture", [
            { no: 1, name: "deposit_redemption_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 2, name: "sale_id", kind: "message", T: () => UUID },
            { no: 3, name: "deposit_purchase_ledger_entry_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_DepositForfeiture>): LedgerEntry_DepositForfeiture {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_DepositForfeiture>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_DepositForfeiture): LedgerEntry_DepositForfeiture {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID deposit_redemption_ledger_entry_id */ 1:
                    message.depositRedemptionLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.depositRedemptionLedgerEntryId);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 2:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID deposit_purchase_ledger_entry_id */ 3:
                    message.depositPurchaseLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.depositPurchaseLedgerEntryId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_DepositForfeiture, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID deposit_redemption_ledger_entry_id = 1; */
        if (message.depositRedemptionLedgerEntryId)
            UUID.internalBinaryWrite(message.depositRedemptionLedgerEntryId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 2; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID deposit_purchase_ledger_entry_id = 3; */
        if (message.depositPurchaseLedgerEntryId)
            UUID.internalBinaryWrite(message.depositPurchaseLedgerEntryId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.DepositForfeiture
 */
export const LedgerEntry_DepositForfeiture = new LedgerEntry_DepositForfeiture$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_FinancingCharge$Type extends MessageType<LedgerEntry_FinancingCharge> {
    constructor() {
        super("rd.ledger.LedgerEntry.FinancingCharge", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "assessed_purchases_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 3, name: "assessed_finance_charges_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 4, name: "assessment_rate", kind: "message", T: () => Decimal },
            { no: 5, name: "adjustment_amount", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_FinancingCharge>): LedgerEntry_FinancingCharge {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.assessedPurchasesById = {};
        message.assessedFinanceChargesById = {};
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_FinancingCharge>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_FinancingCharge): LedgerEntry_FinancingCharge {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                case /* map<string, rd.proto.money.Money> assessed_purchases_by_id */ 2:
                    this.binaryReadMap2(message.assessedPurchasesById, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> assessed_finance_charges_by_id */ 3:
                    this.binaryReadMap3(message.assessedFinanceChargesById, reader, options);
                    break;
                case /* rd.proto.decimal.Decimal assessment_rate */ 4:
                    message.assessmentRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.assessmentRate);
                    break;
                case /* rd.proto.money.Money adjustment_amount */ 5:
                    message.adjustmentAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.adjustmentAmount);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: LedgerEntry_FinancingCharge["assessedPurchasesById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_FinancingCharge["assessedPurchasesById"] | undefined, val: LedgerEntry_FinancingCharge["assessedPurchasesById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.FinancingCharge.assessed_purchases_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap3(map: LedgerEntry_FinancingCharge["assessedFinanceChargesById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_FinancingCharge["assessedFinanceChargesById"] | undefined, val: LedgerEntry_FinancingCharge["assessedFinanceChargesById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.FinancingCharge.assessed_finance_charges_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: LedgerEntry_FinancingCharge, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        /* map<string, rd.proto.money.Money> assessed_purchases_by_id = 2; */
        for (let k of globalThis.Object.keys(message.assessedPurchasesById)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.assessedPurchasesById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> assessed_finance_charges_by_id = 3; */
        for (let k of globalThis.Object.keys(message.assessedFinanceChargesById)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.assessedFinanceChargesById[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.decimal.Decimal assessment_rate = 4; */
        if (message.assessmentRate)
            Decimal.internalBinaryWrite(message.assessmentRate, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money adjustment_amount = 5; */
        if (message.adjustmentAmount)
            Money.internalBinaryWrite(message.adjustmentAmount, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.FinancingCharge
 */
export const LedgerEntry_FinancingCharge = new LedgerEntry_FinancingCharge$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_ReceivablesMetadata$Type extends MessageType<LedgerEntry_ReceivablesMetadata> {
    constructor() {
        super("rd.ledger.LedgerEntry.ReceivablesMetadata", [
            { no: 1, name: "running_balance_by_customer_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_ReceivablesMetadata>): LedgerEntry_ReceivablesMetadata {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.runningBalanceByCustomerId = {};
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_ReceivablesMetadata>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_ReceivablesMetadata): LedgerEntry_ReceivablesMetadata {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, rd.proto.money.Money> running_balance_by_customer_id */ 1:
                    this.binaryReadMap1(message.runningBalanceByCustomerId, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: LedgerEntry_ReceivablesMetadata["runningBalanceByCustomerId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_ReceivablesMetadata["runningBalanceByCustomerId"] | undefined, val: LedgerEntry_ReceivablesMetadata["runningBalanceByCustomerId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.ReceivablesMetadata.running_balance_by_customer_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: LedgerEntry_ReceivablesMetadata, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, rd.proto.money.Money> running_balance_by_customer_id = 1; */
        for (let k of globalThis.Object.keys(message.runningBalanceByCustomerId)) {
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.runningBalanceByCustomerId[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.ReceivablesMetadata
 */
export const LedgerEntry_ReceivablesMetadata = new LedgerEntry_ReceivablesMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_GiftCardActivation$Type extends MessageType<LedgerEntry_GiftCardActivation> {
    constructor() {
        super("rd.ledger.LedgerEntry.GiftCardActivation", [
            { no: 1, name: "gift_card_id", kind: "message", T: () => UUID },
            { no: 2, name: "sale_id", kind: "message", T: () => UUID },
            { no: 4, name: "non_sale_gift_card_activation", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_GiftCardActivation>): LedgerEntry_GiftCardActivation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.nonSaleGiftCardActivation = false;
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_GiftCardActivation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_GiftCardActivation): LedgerEntry_GiftCardActivation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID gift_card_id */ 1:
                    message.giftCardId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.giftCardId);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 2:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* bool non_sale_gift_card_activation */ 4:
                    message.nonSaleGiftCardActivation = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_GiftCardActivation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID gift_card_id = 1; */
        if (message.giftCardId)
            UUID.internalBinaryWrite(message.giftCardId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 2; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool non_sale_gift_card_activation = 4; */
        if (message.nonSaleGiftCardActivation !== false)
            writer.tag(4, WireType.Varint).bool(message.nonSaleGiftCardActivation);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.GiftCardActivation
 */
export const LedgerEntry_GiftCardActivation = new LedgerEntry_GiftCardActivation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_GiftCardDeactivation$Type extends MessageType<LedgerEntry_GiftCardDeactivation> {
    constructor() {
        super("rd.ledger.LedgerEntry.GiftCardDeactivation", [
            { no: 1, name: "gift_card_activation_ledger_entry_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_GiftCardDeactivation>): LedgerEntry_GiftCardDeactivation {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_GiftCardDeactivation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_GiftCardDeactivation): LedgerEntry_GiftCardDeactivation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID gift_card_activation_ledger_entry_id */ 1:
                    message.giftCardActivationLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.giftCardActivationLedgerEntryId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerEntry_GiftCardDeactivation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID gift_card_activation_ledger_entry_id = 1; */
        if (message.giftCardActivationLedgerEntryId)
            UUID.internalBinaryWrite(message.giftCardActivationLedgerEntryId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.GiftCardDeactivation
 */
export const LedgerEntry_GiftCardDeactivation = new LedgerEntry_GiftCardDeactivation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerEntry_LoyaltyPoints$Type extends MessageType<LedgerEntry_LoyaltyPoints> {
    constructor() {
        super("rd.ledger.LedgerEntry.LoyaltyPoints", [
            { no: 1, name: "points", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "subtype", kind: "enum", T: () => ["rd.ledger.LedgerEntry.LoyaltyPoints.Subtype", LedgerEntry_LoyaltyPoints_Subtype, "SUBTYPE_"] },
            { no: 3, name: "points_per_sale_product_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ } },
            { no: 4, name: "source_le_id", kind: "message", T: () => UUID },
            { no: 5, name: "sale_id", kind: "message", T: () => UUID },
            { no: 6, name: "reward_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<LedgerEntry_LoyaltyPoints>): LedgerEntry_LoyaltyPoints {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.points = 0n;
        message.subtype = 0;
        message.pointsPerSaleProductId = {};
        if (value !== undefined)
            reflectionMergePartial<LedgerEntry_LoyaltyPoints>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerEntry_LoyaltyPoints): LedgerEntry_LoyaltyPoints {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 points */ 1:
                    message.points = reader.int64().toBigInt();
                    break;
                case /* rd.ledger.LedgerEntry.LoyaltyPoints.Subtype subtype */ 2:
                    message.subtype = reader.int32();
                    break;
                case /* map<string, int64> points_per_sale_product_id */ 3:
                    this.binaryReadMap3(message.pointsPerSaleProductId, reader, options);
                    break;
                case /* rd.proto.uuid.UUID source_le_id */ 4:
                    message.sourceLeId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.sourceLeId);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 5:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID reward_id */ 6:
                    message.rewardId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.rewardId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: LedgerEntry_LoyaltyPoints["pointsPerSaleProductId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof LedgerEntry_LoyaltyPoints["pointsPerSaleProductId"] | undefined, val: LedgerEntry_LoyaltyPoints["pointsPerSaleProductId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.int64().toBigInt();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.ledger.LedgerEntry.LoyaltyPoints.points_per_sale_product_id");
            }
        }
        map[key ?? ""] = val ?? 0n;
    }
    internalBinaryWrite(message: LedgerEntry_LoyaltyPoints, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 points = 1; */
        if (message.points !== 0n)
            writer.tag(1, WireType.Varint).int64(message.points);
        /* rd.ledger.LedgerEntry.LoyaltyPoints.Subtype subtype = 2; */
        if (message.subtype !== 0)
            writer.tag(2, WireType.Varint).int32(message.subtype);
        /* map<string, int64> points_per_sale_product_id = 3; */
        for (let k of globalThis.Object.keys(message.pointsPerSaleProductId))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).int64(message.pointsPerSaleProductId[k]).join();
        /* rd.proto.uuid.UUID source_le_id = 4; */
        if (message.sourceLeId)
            UUID.internalBinaryWrite(message.sourceLeId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 5; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID reward_id = 6; */
        if (message.rewardId)
            UUID.internalBinaryWrite(message.rewardId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerEntry.LoyaltyPoints
 */
export const LedgerEntry_LoyaltyPoints = new LedgerEntry_LoyaltyPoints$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerMethods$Type extends MessageType<LedgerMethods> {
    constructor() {
        super("rd.ledger.LedgerMethods", [
            { no: 1, name: "methods", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LedgerMethods_Method }
        ]);
    }
    create(value?: PartialMessage<LedgerMethods>): LedgerMethods {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.methods = [];
        if (value !== undefined)
            reflectionMergePartial<LedgerMethods>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerMethods): LedgerMethods {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.ledger.LedgerMethods.Method methods */ 1:
                    message.methods.push(LedgerMethods_Method.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerMethods, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.ledger.LedgerMethods.Method methods = 1; */
        for (let i = 0; i < message.methods.length; i++)
            LedgerMethods_Method.internalBinaryWrite(message.methods[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerMethods
 */
export const LedgerMethods = new LedgerMethods$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LedgerMethods_Method$Type extends MessageType<LedgerMethods_Method> {
    constructor() {
        super("rd.ledger.LedgerMethods.Method", [
            { no: 1, name: "method_id", kind: "message", T: () => UUID },
            { no: 2, name: "method_type", kind: "enum", T: () => ["rd.company.tender.Method.Type", Method_Type, "TYPE_"] },
            { no: 3, name: "method_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "amount", kind: "message", T: () => Money },
            { no: 5, name: "check_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "card", kind: "message", T: () => Card },
            { no: 7, name: "cash_received", kind: "message", T: () => Money },
            { no: 8, name: "custom_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "bank_payment_method", kind: "message", T: () => BankPaymentMethod },
            { no: 10, name: "surcharge", kind: "message", T: () => Money },
            { no: 11, name: "surcharge_tax", kind: "message", T: () => Money },
            { no: 12, name: "accounted_at", kind: "message", T: () => Timestamp },
            { no: 13, name: "gift_card_number_last_4", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "gift_card_id", kind: "message", T: () => UUID },
            { no: 15, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "is_interac", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<LedgerMethods_Method>): LedgerMethods_Method {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.methodType = 0;
        message.methodName = "";
        message.checkNumber = "";
        message.customNote = "";
        message.giftCardNumberLast4 = "";
        message.displayName = "";
        message.isInterac = false;
        if (value !== undefined)
            reflectionMergePartial<LedgerMethods_Method>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LedgerMethods_Method): LedgerMethods_Method {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID method_id */ 1:
                    message.methodId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.methodId);
                    break;
                case /* rd.company.tender.Method.Type method_type */ 2:
                    message.methodType = reader.int32();
                    break;
                case /* string method_name */ 3:
                    message.methodName = reader.string();
                    break;
                case /* rd.proto.money.Money amount */ 4:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* string check_number */ 5:
                    message.checkNumber = reader.string();
                    break;
                case /* rd.payments.Card card */ 6:
                    message.card = Card.internalBinaryRead(reader, reader.uint32(), options, message.card);
                    break;
                case /* rd.proto.money.Money cash_received */ 7:
                    message.cashReceived = Money.internalBinaryRead(reader, reader.uint32(), options, message.cashReceived);
                    break;
                case /* string custom_note */ 8:
                    message.customNote = reader.string();
                    break;
                case /* rd.payments.BankPaymentMethod bank_payment_method */ 9:
                    message.bankPaymentMethod = BankPaymentMethod.internalBinaryRead(reader, reader.uint32(), options, message.bankPaymentMethod);
                    break;
                case /* rd.proto.money.Money surcharge */ 10:
                    message.surcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.surcharge);
                    break;
                case /* rd.proto.money.Money surcharge_tax */ 11:
                    message.surchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.surchargeTax);
                    break;
                case /* google.protobuf.Timestamp accounted_at */ 12:
                    message.accountedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.accountedAt);
                    break;
                case /* string gift_card_number_last_4 */ 13:
                    message.giftCardNumberLast4 = reader.string();
                    break;
                case /* rd.proto.uuid.UUID gift_card_id */ 14:
                    message.giftCardId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.giftCardId);
                    break;
                case /* string display_name */ 15:
                    message.displayName = reader.string();
                    break;
                case /* bool is_interac */ 16:
                    message.isInterac = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LedgerMethods_Method, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID method_id = 1; */
        if (message.methodId)
            UUID.internalBinaryWrite(message.methodId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.tender.Method.Type method_type = 2; */
        if (message.methodType !== 0)
            writer.tag(2, WireType.Varint).int32(message.methodType);
        /* string method_name = 3; */
        if (message.methodName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.methodName);
        /* rd.proto.money.Money amount = 4; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string check_number = 5; */
        if (message.checkNumber !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.checkNumber);
        /* rd.payments.Card card = 6; */
        if (message.card)
            Card.internalBinaryWrite(message.card, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money cash_received = 7; */
        if (message.cashReceived)
            Money.internalBinaryWrite(message.cashReceived, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string custom_note = 8; */
        if (message.customNote !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.customNote);
        /* rd.payments.BankPaymentMethod bank_payment_method = 9; */
        if (message.bankPaymentMethod)
            BankPaymentMethod.internalBinaryWrite(message.bankPaymentMethod, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money surcharge = 10; */
        if (message.surcharge)
            Money.internalBinaryWrite(message.surcharge, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money surcharge_tax = 11; */
        if (message.surchargeTax)
            Money.internalBinaryWrite(message.surchargeTax, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp accounted_at = 12; */
        if (message.accountedAt)
            Timestamp.internalBinaryWrite(message.accountedAt, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* string gift_card_number_last_4 = 13; */
        if (message.giftCardNumberLast4 !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.giftCardNumberLast4);
        /* rd.proto.uuid.UUID gift_card_id = 14; */
        if (message.giftCardId)
            UUID.internalBinaryWrite(message.giftCardId, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 15; */
        if (message.displayName !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.displayName);
        /* bool is_interac = 16; */
        if (message.isInterac !== false)
            writer.tag(16, WireType.Varint).bool(message.isInterac);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.LedgerMethods.Method
 */
export const LedgerMethods_Method = new LedgerMethods_Method$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReceiptPurchaseMethods$Type extends MessageType<ReceiptPurchaseMethods> {
    constructor() {
        super("rd.ledger.ReceiptPurchaseMethods", [
            { no: 1, name: "methods", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ReceiptPurchaseMethods_Method }
        ]);
    }
    create(value?: PartialMessage<ReceiptPurchaseMethods>): ReceiptPurchaseMethods {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.methods = [];
        if (value !== undefined)
            reflectionMergePartial<ReceiptPurchaseMethods>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReceiptPurchaseMethods): ReceiptPurchaseMethods {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.ledger.ReceiptPurchaseMethods.Method methods */ 1:
                    message.methods.push(ReceiptPurchaseMethods_Method.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReceiptPurchaseMethods, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.ledger.ReceiptPurchaseMethods.Method methods = 1; */
        for (let i = 0; i < message.methods.length; i++)
            ReceiptPurchaseMethods_Method.internalBinaryWrite(message.methods[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.ReceiptPurchaseMethods
 */
export const ReceiptPurchaseMethods = new ReceiptPurchaseMethods$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReceiptPurchaseMethods_Method$Type extends MessageType<ReceiptPurchaseMethods_Method> {
    constructor() {
        super("rd.ledger.ReceiptPurchaseMethods.Method", [
            { no: 1, name: "method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "amount", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<ReceiptPurchaseMethods_Method>): ReceiptPurchaseMethods_Method {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.method = "";
        if (value !== undefined)
            reflectionMergePartial<ReceiptPurchaseMethods_Method>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReceiptPurchaseMethods_Method): ReceiptPurchaseMethods_Method {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string method */ 1:
                    message.method = reader.string();
                    break;
                case /* rd.proto.money.Money amount */ 2:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReceiptPurchaseMethods_Method, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string method = 1; */
        if (message.method !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.method);
        /* rd.proto.money.Money amount = 2; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.ledger.ReceiptPurchaseMethods.Method
 */
export const ReceiptPurchaseMethods_Method = new ReceiptPurchaseMethods_Method$Type();
